import { SharedService } from './../../../common/services/shared-service.service';
import {
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Column } from '@usitsdasdesign/dds-ng/shared';
import { ButtonComponent, ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { ToastOptions, ToastService } from '@usitsdasdesign/dds-ng/toast';
import { SubmissionService } from '../../../http/intake/submission.service';
import { forkJoin, Observable, Subject, takeUntil } from 'rxjs';
import {
  lepDataValue,
  riskManagerTableHeaderData,
} from '../opportunity-details-settings';
import {
  IntakeConstant,
  IntakeDocTableIdMapper,
} from '../../constants/intake.constant';
import {
  ADD_REVIEWER_BTN_OPTIONS,
  ARCHIVE_AND_COMPLETE_BTN_OPTIONS,
  CO_CHANGE_SCOPE_RADIO_GROUP_VALUE,
  CO_SEARCH_OPTION,
  PrimaryButton,
  COMMON_BTN_OPTIONS,
  RADIO_GROUP_OPTIONS_FOR_CO_CHANGE_SCOPE,
  RADIO_GROUP_OPTIONS_FOR_OTHER_SUBTYPE,
  RADIO_GROUP_OPTIONS_FOR_RFP,
  REP_RADIO_GROUP_VALUE,
  RESUBMIT_FOR_REVIEW_BTN_OPTIONS,
  SHOW_MORE_BTN_OPTIONS,
  SUBMIT_BTN_OPTIONS,
  toastMessage,
  submittedMessage,
  returnForReworkMessage,
  resubmittedToastMessage,
  OPT_OUT_SELF_REVIEW_BTN_OPTIONS,
  SELF_REVIEW_BTN_OPTIONS,
  isSelfReviewButtonVisible,
  intakeToastOption,
  UpdateReviewerActions,
  completedToastMessage,
  withoutRmToastMessage,
  SwapButtonOptions,
  DarkTooltipOptions,
  optedOutSelfReviewToastMessageRM,
} from './submission-common-section.helper';
import { IntakeOppertunitySubmissionStatus } from '../../constants/intake-submission-status.enum';
import { IntakeDocumentSubmissionTypeCode } from '../../constants/intake-submission-type.enum';
import { IAutosaverOptions, Saver } from '../../../common/autosaver/saver';
import { AutosaverService } from '../../../common/autosaver/autosaver.service';
import { latestOpportunityDetails } from '../../../common/models/latestOpportunityDetails';
import {
  LepValue,
  OpportunityDetailsNavModel,
} from '../../../common/models/opportunity-details.model';
import { ProgressIndicatorService } from '../../../common/services/progress-indicator.service';
import {
  DiscontinuedRequestModel,
  EmitUpdatedTitleModal,
  IntakeSubmissionDeatilsCommonSectionWorkflowSelectedDocumentsModal,
  IntakeSubmissionDetailsCommonSectionDataReceivedModal,
  IntakeSubmissionDetailsCommonSectionDataSendingModal,
  SubmissionApprovers,
  SwiftDetails,
} from '../../../common/models/intake-submission-details-common-section.model';
import { ActivatedRoute, Router } from '@angular/router';
import {
  configurationType,
  PermissionsObj,
  SubmissionSubType,
} from '../../../common/models/common-models';
import { RoleEnum, RoleIdMapper } from '../../constants/Role.enum';
import {
  copyToClipboard,
  isTheDocumentHasCompletedElSOw,
  randomString,
} from '../../common/intake.util';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';

import { DocumentSelectionPopupComponent } from './document-selection-popup/document-selection-popup.component';
import { DocumentComponent } from './document/document.component';
import { IntakeDocumentTableModel } from '../../../common/models/intake-document-table.model';
import { StatusEnum } from '../../../common/constants/status-enum';
import { AdministrativelyClosePopupComponent } from './administratively-close-popup/administratively-close-popup/administratively-close-popup.component';
import { DiscontinuedModalOnCloseRequestModel } from '../../../common/models/show-all-popup-model';
import { CommonService } from '../../../http/intake/common.service';
import { OppertunitySubmissionStatusCode } from '../../../common/models/oppertunity-submission-statusCode.model';

import { SubmissionActionHistoryModel } from '../../../common/models/submission-action.model';
import { RoleService } from '../../../http/intake/role.service';
import { DiscontinueModalComponent } from './discontinue-modal/discontinue-modal.component';
import { ResetStatusPopupComponent } from './reset-status-popup/reset-status-popup.component';
import { SecurityWebapiService } from '../../../http/security/security-webapi.service';
import { OptOutPopupComponent } from '../../intake-common-popups/opt-out-popup/opt-out-popup.component';
import {
  IntakeOptOutPopUpDataModel,
  NavigationInfoRelinkModel,
} from '../../../common/models/initiateSubmission.model';
import { UserService } from '../../../http/user.service';
import {
  WbsArchiveReceivedModel,
  WbsWithArchiveDetailsModel,
} from '../../../common/models/wbs-picker.model';
import { DocumentService } from '../../../http/document/document.service';
import { BrowserTabConstant } from '../../../common/constants/browser-tab-constant';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonHelperService } from '../../../common/services/common-helper.service';
import {
  archiveDocStatus,
  DocumentStatus,
  draftDocStatus,
  resubmitDraftDocStatus,
  reviewedDocStatus,
} from '../../constants/document-status.enum';
import { RelinkOppPopupComponent } from './relink-opp-popup/relink-opp-popup.component';
import { EclipseHeaderService } from '../../../http/eclipse-header.service';
import {
  DropdownItemOptions,
  DropdownOptions,
} from '@usitsdasdesign/dds-ng/dropdown';
import { TooltipOptions } from '@usitsdasdesign/dds-ng/tooltip';
import { SharedConstant } from '../../../common/constants/shared.constant';
import { IntakeDocumentType } from '../../constants/intake-document-type.enum';
import { compareDates } from '../../../common/utils/common-util';
@Component({
  selector: 'app-submission-common-section',
  templateUrl: './submission-common-section.component.html',
  styleUrl: './submission-common-section.component.less',
})
export class SubmissionCommonSectionComponent
  implements OnInit, OnChanges, OnDestroy
{
  _EMPTY = SharedConstant.EMPTY_STRING;
  @Input() dataOpportunityId: string = this._EMPTY;
  @Input() dataSubmissionId: number | null = null;
  @Input() opportunityDocsCount: number = 0;
  @Input() dataSubmissionSubTypeCode: number | null = null;
  @Input() set dataSubmissionTypeCode(submissionTypeCode: string) {
    this.setSubMissionCodeDetails(submissionTypeCode);
  }
  @Input() permissionObj: PermissionsObj = {} as PermissionsObj;
  @Input() dataLepValue: LepValue = lepDataValue;
  @Input() opportunityDocs!: OpportunityDetailsNavModel[];

  @Output() valueChange: EventEmitter<{
    checkFlag: boolean;
    closeoutFormFlags: {
      resubmitFormCompleted: boolean;
      archiveFormCompleted: boolean;
    };
  }> = new EventEmitter<{
    checkFlag: boolean;
    closeoutFormFlags: {
      resubmitFormCompleted: boolean;
      archiveFormCompleted: boolean;
    };
  }>();
  @Output() updateTitle: EventEmitter<EmitUpdatedTitleModal> =
    new EventEmitter<EmitUpdatedTitleModal>();
  @Output() updateLeftMenu: EventEmitter<string> = new EventEmitter<string>();
  @Output() updatePermissions: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(DocumentComponent) documentComponent!: DocumentComponent;

  isEligibleTechnicalReviewer: boolean = false;
  isFinalDocumentAcceptedMsgShow: boolean = true;
  oppertunityStatusCodes!: OppertunitySubmissionStatusCode[];
  selfReviewDocBanner: string = this._EMPTY;
  defaultEmptyFields: string = SharedConstant.DEFAULT_FOR_EMPTY_FIELDS;
  archiveDetails!: WbsArchiveReceivedModel;
  swiftDetails!: SwiftDetails;
  apiCallHandling: boolean = false;
  isArchiveFeatureEnable: boolean = false;
  iswbsCheckboxSelected: boolean = false;
  archiveNumberSelected: string | null | undefined = IntakeConstant.EMPTY_SPACE;
  isArchiveNotListed: boolean = false;
  isCopied: boolean = false;
  UPLOAD_DOCUMENTS_LABEL_DRAFT!: string;
  UPLOAD_DOCUMENTS_LABEL_DRAFT_EL_SOW!: string;
  submissionTypeCode!: string;
  submissionData!: IntakeSubmissionDetailsCommonSectionDataReceivedModal;
  titleValue: string = this._EMPTY;
  isEditingTitle: boolean = false;
  copySuccess: string | null = null;
  submissionId: number = 0;
  submissionStatus: string | undefined = this._EMPTY;
  selfReviewEligibility: string | undefined = this._EMPTY;
  selfReviewEligibilityStatusId: number | string | undefined;
  optOutSelfReviewDate: string | null = null;
  updatedRiskManagerDetails!: SubmissionApprovers[];
  tempUpdatedRiskManagerDetails!: SubmissionApprovers[];
  isEmployeePresent: boolean = false;
  selectedRiskManagers: string[] = [];
  readonly #unsubscriber$: Subject<any> = new Subject<any>();
  isOpportunitySelected: boolean = true;
  textareaOptions: any = IntakeConstant.TEXT_AREA_SETTINGS_GLOBAL;
  enter_text_placeholder = IntakeConstant.ENTER_TEXT_PLACEHOLDER;
  // Submission Type code
  submissionTypeCodePro = IntakeDocumentSubmissionTypeCode.PRO;
  submissionTypeCodeDelivery = IntakeDocumentSubmissionTypeCode.DEL;
  submissionTypeCodeOther = IntakeDocumentSubmissionTypeCode.OTH;
  submissionTypeCodeCO = IntakeDocumentSubmissionTypeCode.CO;
  submissionTypeCodeELSOW = IntakeDocumentSubmissionTypeCode.EL_SOW;
  // Submission Status
  submissionStatusDraft: IntakeOppertunitySubmissionStatus =
    IntakeOppertunitySubmissionStatus.DRAFT;
  submissionStatusResubmitted: IntakeOppertunitySubmissionStatus =
    IntakeOppertunitySubmissionStatus.RESUBMITTED;
  submissionStatusSubmitted: IntakeOppertunitySubmissionStatus =
    IntakeOppertunitySubmissionStatus.SUBMITTED;
  submissionStatusReturnForRework: IntakeOppertunitySubmissionStatus =
    IntakeOppertunitySubmissionStatus.RETURN_FOR_REWORK;
  submissionStatusSelfPendingCloseout: IntakeOppertunitySubmissionStatus =
    IntakeOppertunitySubmissionStatus.SELF_REVIEWED_PENDING_CLOSEOUT;
  submissionStatusRMPendingCloseout: IntakeOppertunitySubmissionStatus =
    IntakeOppertunitySubmissionStatus.RM_REVIEWED_PENDING_CLOSEOUT;
  submissionStatusIncompletePendingCloseout: IntakeOppertunitySubmissionStatus =
    IntakeOppertunitySubmissionStatus.INCOMPLETE_REVIEW_PENDING_CLOSEOUT;

  RFP_radioGroupOptions: any = RADIO_GROUP_OPTIONS_FOR_RFP;
  REP_radio_values: any[] = REP_RADIO_GROUP_VALUE;
  other_subtype_radioGroupOptions: any = RADIO_GROUP_OPTIONS_FOR_OTHER_SUBTYPE;
  COChangeScope_radioGroupOptions: any =
    RADIO_GROUP_OPTIONS_FOR_CO_CHANGE_SCOPE;
  COChangeScope_radio_values: any[] = CO_CHANGE_SCOPE_RADIO_GROUP_VALUE;
  showMoreOptions: any = { ...SHOW_MORE_BTN_OPTIONS };
  // Roles
  roleAdditionalReviewer: string = RoleEnum.REVIEWER;
  roleTechnicalOrIndependentRM: string =
    RoleEnum.TECHNICAL_INDEPENDENT_RISK_MANAGER;
  roleRiskManager: string = RoleEnum.RISK_MANAGER;
  roleSupportingRiskManager: string = RoleEnum.SUPPORTING_RISK_MANAGER;
  roleSpecializedRiskManager: string = RoleEnum.SPECIALIZED_RISK_MANAGER;
  roleRMSupport: string = RoleEnum.RM_SUPPORT_GLOBAL;
  roleSystemAdministrator: string = RoleEnum.SYSTEM_ADMINISTRATOR;

  private timeoutId: ReturnType<typeof setTimeout> | null = null;
  riskManagerTableHeader: Column[] = riskManagerTableHeaderData;
  isValidDocumentUploaded: boolean = false;
  co_draft_Document_Uploaded: boolean = false;
  changeOrderStatus: boolean = false;
  loggedInEmployeeId: string = this._EMPTY;
  configLableDocument: string = this._EMPTY;
  configData: configurationType[] = [];
  submissionStatusCommonSection: string = this._EMPTY;
  submissionActionHistory: SubmissionActionHistoryModel[] = [];
  showReviewAndReturnBtn: boolean = false;
  optOutOfSelfReviewReason: string | null | undefined = this._EMPTY;
  showSubmitBtnWhnDraft: boolean = false;

  allDocTypeSelectedIsSupporting: boolean = true;
  coOppDonotMatchMessage: string = this._EMPTY;
  showReviewBtn: boolean = false;
  submitLabel: string = IntakeConstant.SUBMIT_BTN_LABEL;
  archiveAndCompleteBtnLabel: string =
    IntakeConstant.ARCHIVE_AND_COMPLETE_BTN_LABEL;
  reSubmitForReviewLabel: string = IntakeConstant.RESUBMIT_FOR_REVIEW_BTN_LABEL;
  selfReviewBtnLabel: string = IntakeConstant.SELF_REVIEW_BTN_LABEL;
  optOutOfSelfReviewBtnLabel: string =
    IntakeConstant.OPT_OUT_OF_SELF_REVIEW_BTN_LABEL;
  submitButtonOptions: ButtonOptions = SUBMIT_BTN_OPTIONS;
  options: ButtonOptions = ADD_REVIEWER_BTN_OPTIONS;
  archiveAndCompleteBtnOption = ARCHIVE_AND_COMPLETE_BTN_OPTIONS;
  resubmitForReviewBtnOption = RESUBMIT_FOR_REVIEW_BTN_OPTIONS;
  selfReviewBtnOption = SELF_REVIEW_BTN_OPTIONS;
  optOutOfSelfReviewBtnOption = OPT_OUT_SELF_REVIEW_BTN_OPTIONS;
  toastOptions: ToastOptions = toastMessage;
  submittedToastOption: ToastOptions = submittedMessage;
  submittedToastOptionTitle: string = this._EMPTY;
  submittedToastOptionMessage: string = this._EMPTY;
  returnForReworkToastOption: ToastOptions = returnForReworkMessage;
  resubmittedToastOption: ToastOptions = resubmittedToastMessage;
  optedOutToastOption: ToastOptions = optedOutSelfReviewToastMessageRM;
  compltedToastOption: ToastOptions = completedToastMessage;
  withoutRMToastOption: ToastOptions = withoutRmToastMessage;
  withoutRMToastOptionMessage: string = this._EMPTY;

  primaryButtonOptions: ButtonOptions = PrimaryButton;
  primaryLoudButtonOptions: ButtonOptions = COMMON_BTN_OPTIONS;
  internalQrmCommunicationTextareaMaxlength: number =
    IntakeConstant.TEXTAREA_CHAR_LIMIT_BIGGEST;
  public model: IntakeSubmissionDetailsCommonSectionDataSendingModal =
    {} as IntakeSubmissionDetailsCommonSectionDataSendingModal;
  public commonSectionFormModule!: Saver;
  isShowMoreDocumentNotes: boolean = false;
  showMoreText: string = IntakeConstant.SHOW_MORE_TEXT;
  coHasParentOpportunityNumber: boolean = false;
  coSearchOption = CO_SEARCH_OPTION;
  selectedOportunityForCO = this._EMPTY;
  isCheckboxCheckedForNoEL_SOW: boolean = true;
  readonly #route = inject(ActivatedRoute);
  opportunityNumber!: string;
  otherSubTypes$!: Observable<SubmissionSubType[]>;
  submissionTypeId: number = 0;
  submissionStatusId: number = 0;
  lepAcknowledgedBy: null | string = null;
  lepAcknowledgementDate: null | string = null;
  lepReviewedBy: null | string = null;
  showLepConfirmationMessage: boolean = false;
  employeeIdNumber: number = 0;
  showActionsHeader: boolean = false;
  isArchiveAndCompleteBtnDisabled: boolean = true;
  documentTableData: IntakeDocumentTableModel[] = [];

  DOC_submissionStatusDraft: string = DocumentStatus.Draft;
  roleIdMapper: any = RoleIdMapper;
  showResetActionMessage: boolean = false;
  resetActionMessage?: SubmissionActionHistoryModel;
  isSelfReviewButtonVisible: boolean = false;
  valueYes: string = IntakeConstant.YES;

  currentLoggedInUser: string = this._EMPTY;
  otherSubTypes: SubmissionSubType[] = [];
  userRolesAccess: any = [];
  uploadedDocData: IntakeDocumentTableModel[] = [];
  disableAddReviewerButton: boolean = false;
  reviewerDetailsFromReviewerApi: SubmissionApprovers[] = [];
  showRiskManagerLabel: boolean = false;
  showSupportingRiskManagerLabel: boolean = false;
  showSpecializedRiskManagerLabel: boolean = false;
  isSubmissionStatusRMorSelfReviewed: boolean = false;
  collapseAccordion: boolean = true;
  collapseSelfReviewAccordion: boolean = true;

  primaryDgmfId: string | null | undefined = IntakeConstant.EMPTY_SPACE;
  primaryGmdmId: string | null | undefined = IntakeConstant.EMPTY_SPACE;
  primarySwiftId: string | null | undefined = IntakeConstant.EMPTY_SPACE;
  pursuitLeaderId: string | null | undefined = IntakeConstant.EMPTY_SPACE;
  pursuitLeaderName: string | null | undefined = IntakeConstant.EMPTY_SPACE;
  submissionTypeSubId: number | null | undefined = null;

  rmReviewedGuidanceNoteHeader: string = this._EMPTY;
  rmReviewedGuidanceNoteBody: string = this._EMPTY;

  discontinueModalOpen: boolean = false;
  resestModalOpen: boolean = false;
  adminModalOpen: boolean = false;

  isOpporunityLevelFormCompleted: boolean = false;

  // TODO: below 2 messages need to come from backend
  pendingCloseOutNonSelfReviewMsg =
    'Risk management has reviewed your submission. Download the reviewed document and incorporate any comments or feedback from Risk Management into the document prior to sharing it with the client.';
  pendingCloseOutSelfReviewMsg =
    'This submission qualified for Self-review and has not been reviewed by risk management. The LEP should perform a final review of the document prior to sharing it with the client. Return to the application to finalize, archive and move submission to complete.';

  uploadDocNote: string = IntakeConstant.UPLOAD_DOCUMENT_NOTE;
  isSubmissionDataLoading: boolean = true;

  swapReviewedDocResubmit: string = 'Access reviewed document(s) / Resubmit';
  swapArchiveFinalize: string = 'Archive / Finalize submission';
  swapButtonOptions: DropdownOptions = SwapButtonOptions;
  swapSectionOptions: DropdownItemOptions[] = [
    {
      heading: this.swapReviewedDocResubmit,
      value: this.swapReviewedDocResubmit,
    },
    {
      heading: this.swapArchiveFinalize,
      value: this.swapArchiveFinalize,
    },
  ];
  selectedSwapAction: string = this._EMPTY;
  tooltipOptions: TooltipOptions = DarkTooltipOptions;
  reviewDocSubmitTooltip: string =
    'Access RM reviewed documents or resubmit an updated document for risk management review';
  archiveFinalizeTooltip: string =
    'Upload final/executed document for archiving';
  draftDocStatusArr: string[] = draftDocStatus;
  resubmitDraftDocStatusArr: string[] = resubmitDraftDocStatus;
  reviewedDocStatusArr: string[] = reviewedDocStatus;
  archiveDocStatusArr: string[] = archiveDocStatus;
  isValidDocInResubmitTable: boolean = false;
  isArchiveReadyDocPresent: boolean = false;
  showArchiveReadyDocNote: boolean = true; // Remove if we don't change the value in future
  showAdditionalRMDocMsg: boolean = false;
  closeoutFormsCheck: {
    resubmitFormCompleted: boolean;
    archiveFormCompleted: boolean;
  } = {
    resubmitFormCompleted: false,
    archiveFormCompleted: false,
  };
  currentStatusChangeDate: string | null = null;
  tableIdMapper: { [key: string]: number } = IntakeDocTableIdMapper;
  hasRFP: boolean = false;
  hasProposalTypeDoc: boolean = false;
  previousSubmissionStatus: string = this._EMPTY;

  constructor(
    private readonly submissionService: SubmissionService,
    private readonly autosaverService: AutosaverService,
    private readonly modalService: ModalService,
    private readonly progressIndicator: ProgressIndicatorService,
    private readonly toastService: ToastService,
    private readonly commonService: CommonService,
    private readonly roleService: RoleService,
    private readonly securityWebapiService: SecurityWebapiService,
    private readonly documentService: DocumentService,
    private readonly userService: UserService,
    private readonly commonHelperService: CommonHelperService,
    private readonly router: Router,
    private readonly headerService: EclipseHeaderService,
    private readonly sharedService: SharedService
  ) {
    this.model.submissionTitle = this.commonHelperService.trimPrefixEmptySpace(
      this.titleValue
    );
    this.#route.paramMap.subscribe((params) => {
      this.opportunityNumber = params.get('id')!;
    });
  }

  ngOnInit(): void {
    this.commonService.enableAuditTrail(true);

    this.submissionService.swapActionSelected$
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe((action: string) => {
        this.selectedSwapAction = action;
      });

    this.userService.currentLoggedInUser$
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe((user: any) => {
        this.currentLoggedInUser = user?.employeeId;
        this.userRolesAccess = user?.employeeRoles ?? [];
      });

    this.commonService.intakeDocSubmissionStatusObserable$
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (response: OppertunitySubmissionStatusCode[] | null) => {
          if (response && response != null) {
            this.oppertunityStatusCodes = response;
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('Error fetching submission status', err);
        },
      });
    this.loggedInEmployeeId = this.submissionService.employeeId;

    let autoSaverOptions = {
      delay: 500,
      onSuccess: (saver: any, result: any) => {
        return this.postAutoSaveHandler();
      },
    } as IAutosaverOptions;
    this.commonSectionFormModule = this.autosaverService.newSaver(
      'model',
      this,
      async (model) => this.#saveCommonSectionDetails(),
      autoSaverOptions
    );
    this.commonSectionFormModule.start();

    this.submissionService.documentIsValidObservable$.subscribe((status) => {
      this.isValidDocumentUploaded = status;
    });

    this.submissionService.co_draft$.subscribe((status: boolean) => {
      this.co_draft_Document_Uploaded = status;
    });

    if (!this.adminModalOpen) {
      this.submissionService.adminCloseModal$
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe((status) => {
          if (status) {
            this.openModalForAdminCloseOut();
          }
        });
    }

    this.commonService.resetStatusModal$
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe((status: boolean) => {
        if (status && !this.resestModalOpen) {
          this.resestModalOpen = status;
          this.openModalForResetStatus();
        }
      });

    if (!this.discontinueModalOpen) {
      this.submissionService.openDiscontinueModalObservable$
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe((status: boolean) => {
          if (status) {
            this.openDiscontinueModal();
          }
        });
    }
    this.submissionService.IntakeSubmitBtnStatus$.pipe(
      takeUntil(this.#unsubscriber$)
    ).subscribe((status: boolean) => {
      this.allDocTypeSelectedIsSupporting = status;
    });
    this.collapseAccordion = true;

    this.submissionService.openRelinkModel$
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe((status: boolean) => {
        if (status) {
          this.openRelinkModel();
        }
      });

    this.submissionService.hasRFP$
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe((hasRFP: boolean) => {
        this.hasRFP = hasRFP;
      });
  }

  closeDropdown(): void {
    // Find all elements with the 'dds-sticker' class and hide them before navigating to submissison page
    const stickers = document.querySelectorAll('dds-sticker');
    stickers.forEach((element) => {
      if (element.classList.contains('popup_position')) {
        element.classList.remove('popup_position');
      }
      if (element.classList.contains('popup')) {
        element.classList.remove('popup');
      }
      if (!element.classList.contains('hide-dropdown')) {
        element.classList.add('hide-dropdown');
      }
    });

    //To fix the scroll issue due to hiding popup
    window.scrollTo({ top: -48, behavior: 'smooth' });
  }

  openModalForAdminCloseOut(modalBtn?: ButtonComponent): void {
    let modalRef = this.modalService.open(AdministrativelyClosePopupComponent, {
      isFooter: false,
      size: 'lg',
      isInverse: false,
      submissionId: this.submissionId,
    });
    this.adminModalOpen = true;
    modalRef
      .onClosed()
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe(() => {
        this.adminModalOpen = false;
        if (this.submissionId) {
          this.timeoutId = setTimeout(() => {
            this.loadSubmission();
            this.updateLeftMenu.emit(this.opportunityNumber);
          }, IntakeConstant.SET_TIMEOUT_DURATION);
        }
        this.submissionService.openAdminCompleteModal(false);
      });
  }

  openDiscontinueModal(): void {
    let discontinueModalRef = this.modalService.open(
      DiscontinueModalComponent,
      {
        isFooter: true,
        size: 'lg',
        isInverse: false,
      }
    );
    this.discontinueModalOpen = true;
    discontinueModalRef
      .onClosed()
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe((response: DiscontinuedModalOnCloseRequestModel) => {
        this.discontinueModalOpen = false;
        if (this.submissionId) {
          let statusId =
            this.oppertunityStatusCodes.find(
              (status: OppertunitySubmissionStatusCode) =>
                status.statusName ===
                IntakeOppertunitySubmissionStatus.DISCONTINUED
            )?.id ?? 0;
          let discontinuReasonId = response.reasonId ?? 0;
          let discontinueSubmissionActionId = response.actionId ?? 0;
          if (
            statusId > 0 &&
            discontinuReasonId > 0 &&
            discontinueSubmissionActionId > 0
          ) {
            let discontinueDetails: DiscontinuedRequestModel = {
              submissionId: this.submissionId,
              currentStatusId: statusId,
              reasonId: discontinuReasonId,
              submissionActionId: discontinueSubmissionActionId,
            };
            this.submissionService
              .updateDiscontinueAsSubmissionStatus(discontinueDetails)
              .pipe(takeUntil(this.#unsubscriber$))
              .subscribe({
                next: (response) => {
                  //  TODO : as from backend no success response so page is not refreshing
                  this.loadSubmission();
                },
                error: (err: HttpErrorResponse) => {
                  console.error('discontinue save error', err);
                },
              });
            //  TODO : as from backend no success response come remove this force refresh one
            this.timeoutId = setTimeout(() => {
              location.reload();
            }, IntakeConstant.SET_TIMEOUT_DURATION);
          }
        }
        this.submissionService.openDiscontinueSubmissionModal(false);
      });
  }

  SubmissionActionHistoryForAdminComplete(id: string): void {
    this.progressIndicator.show();
    this.submissionService
      .getSubmissionActionHistory(id)
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (response: SubmissionActionHistoryModel[]) => {
          this.submissionActionHistory = response;
          for (let i in this.submissionActionHistory) {
            if (
              this.submissionActionHistory[i].submissionActionId ===
              IntakeConstant.ResetActionID
            ) {
              this.showResetActionMessage = true;
              this.resetActionMessage = this.submissionActionHistory[i];
              return;
            } else {
              this.showResetActionMessage = false;
            }
          }
          this.progressIndicator.hide();
        },
        error: (err: HttpErrorResponse) => {
          this.progressIndicator.hide();
          console.error('Error fetching data', err);
        },
      });
  }

  checkStatusCompletedByAdmin(): boolean {
    if (
      this.submissionStatus ===
      IntakeOppertunitySubmissionStatus.COMPLETED_ADMIN
    ) {
      return true;
    }
    return false;
  }

  checkStatusDiscontinued(): boolean {
    return (
      this.submissionStatus === IntakeOppertunitySubmissionStatus.DISCONTINUED
    );
  }

  disableFieldOnComplete(): boolean {
    return (
      this.submissionStatus ===
      IntakeOppertunitySubmissionStatus.COMPLETED_ADMIN
    );
  }

  openModalForResetStatus(modalBtn?: ButtonComponent): void {
    let resetStatusModalRef;
    this.resestModalOpen = true;
    try {
      resetStatusModalRef = this.modalService.open(ResetStatusPopupComponent, {
        isFooter: false,
        size: 'lg',
        isInverse: false,
        submissionId: this.submissionId,
        submissionStatus: this.submissionStatus,
      });
    } catch (err) {
      this.resestModalOpen = false;
      this.commonService.openResetStatusModal(false);
      console.error('Error opening reset status modal', err);
    }

    resetStatusModalRef
      ?.onClosed()
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe((resetButtonSelected) => {
        this.resestModalOpen = false;
        if (this.submissionId && resetButtonSelected) {
          this.timeoutId = setTimeout(() => {
            this.loadSubmission();
            this.updateLeftMenu.emit(this.opportunityNumber);
          }, IntakeConstant.SET_TIMEOUT_DURATION);
        }
        this.commonService.openResetStatusModal(false);
      });
  }

  getChangeOrderStatus(): void {
    const submissionStatusId = 3;
    if (submissionStatusId) {
      this.submissionService
        .getChangeOrderStatus(this.opportunityNumber, submissionStatusId)
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe({
          next: (response: any) => {
            this.changeOrderStatus = response;
          },
          error: (err: HttpErrorResponse) => {
            console.error('Error fetching submission', err);
          },
        });
    }
  }

  getSubmissionStatusCode(statusName: string): number | undefined {
    return this.oppertunityStatusCodes?.find(
      (status: OppertunitySubmissionStatusCode) =>
        status.statusName === statusName
    )?.id;
  }

  setSubMissionCodeDetails(submissionTypeCode: string): void {
    this.submissionTypeCode = submissionTypeCode;
    this.otherSubTypes$ = this.submissionService.getSubmissionSubTypes(5); // 5 -> Other
    this.otherSubTypes$.subscribe((response) => {
      this.otherSubTypes = response;
    });
  }

  postAutoSaveHandler() {
    //TODO: fetch the save details
  }

  #saveCommonSectionDetails() {
    let commonSectionData = { ...this.model };
    commonSectionData.submissionId = this.submissionId;
    commonSectionData.parentOpportunityNumber = this._EMPTY; // TODO: Check whether this field is used anywhere, else remove
    // TODO: add value from search field for CO, or add from existing value

    if (commonSectionData.coChangeScope != null) {
      commonSectionData.coChangeScope =
        IntakeConstant.YES_NO_CHECKBOX_VALUE_TO_BOOLEAN.get(
          commonSectionData.coChangeScope
        );
    }

    if (commonSectionData.relatedToRFP != null) {
      commonSectionData.relatedToRFP =
        IntakeConstant.YES_NO_CHECKBOX_VALUE_TO_BOOLEAN.get(
          commonSectionData.relatedToRFP
        );
    }

    if (
      this.model.submissionSubTypeId &&
      this.model.submissionSubTypeId != this._EMPTY
    ) {
      commonSectionData.submissionSubTypeId = Number(
        this.model.submissionSubTypeId
      );
    }

    return this.submissionService
      .saveIntakeDetailsCommonData(commonSectionData)
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: () => {
          this.progressIndicator.hide();
          if (this.apiCallHandling) {
            this.COChangeScopeStateChanged();
            this.apiCallHandling = false;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.progressIndicator.hide();
          console.error('Error saving data', err);
        },
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataSubmissionId']) {
      if (!changes['dataSubmissionId']?.isFirstChange()) {
        this.submissionService.setSwapActionSelected(
          SharedConstant.EMPTY_STRING,
          false
        );
      }
    }
    if (
      changes['dataOpportunityId'] ||
      changes['dataSubmissionId'] ||
      changes['submissionTypeCode']
    ) {
      this.scrollToTop();
      this.isSubmissionDataLoading = true;

      this.isArchiveAndCompleteBtnDisabled = true;
      this.showSubmitBtnWhnDraft = false;
      this.loadSubmission();
      this.getLabelConfiguration();
      if (this.submissionTypeCode === this.submissionTypeCodeCO) {
        this.getChangeOrderStatus();
      }
      this.showResetActionMessage = false;
    }
  }

  ngAfterViewInit(): void {
    this.closeDropdown(); // Hide any dropdown if it is open

    //delay the scroll top call for the content to finish loading
    setTimeout(() => {
      this.scrollToTop();
    }, IntakeConstant.SET_TIMEOUT_DURATION);
  }

  checkValidation(): void {
    const validationForm: boolean = this.checkValidationOfForm();
    if (
      this.submissionStatus === this.submissionStatusRMPendingCloseout ||
      this.submissionStatus === this.submissionStatusSelfPendingCloseout ||
      this.submissionStatus === this.submissionStatusIncompletePendingCloseout
    ) {
      if (this.selectedSwapAction === this.swapArchiveFinalize) {
        this.closeoutFormsCheck['archiveFormCompleted'] = validationForm;
      }
      if (this.selectedSwapAction === this.swapReviewedDocResubmit) {
        this.closeoutFormsCheck['resubmitFormCompleted'] = validationForm;
      }
    }
    this.valueChange.emit({
      checkFlag: validationForm,
      closeoutFormFlags: this.closeoutFormsCheck,
    });
  }

  //selecting row of the riskmanager table
  toggleRow(rowEmail: string, index: number): void {
    if (rowEmail && !this.isReviewerCheckboxDisabled(rowEmail, index)) {
      let reviewerIndex = this.updatedRiskManagerDetails.findIndex(
        (approver) => approver.emailId === rowEmail
      );

      // TODO: Uncomment if we need to reset value of isSuppressedNotification flag
      // if (
      //   reviewerIndex !== -1 &&
      //   this.loggedUserReqdInWorkflowTable(reviewerIndex)
      // ) {
      //   this.model.isSuppressedReviewConfirmationNotification = null;
      //   this.#saveCommonSectionDetails();
      // }

      this.updatedRiskManagerDetails[reviewerIndex].isRequired =
        !this.updatedRiskManagerDetails[reviewerIndex].isRequired;
      if (this.updatedRiskManagerDetails[reviewerIndex].isRequired) {
        this.pushInSelectedRiskManagers(
          this.updatedRiskManagerDetails[reviewerIndex].emailId
        );
      } else {
        this.selectedRiskManagers = this.selectedRiskManagers.filter(
          (element) =>
            element != this.updatedRiskManagerDetails[reviewerIndex].emailId
        );
      }
      this.tempUpdatedRiskManagerDetails = structuredClone(
        this.updatedRiskManagerDetails
      );
      this.#updateReviewers(
        UpdateReviewerActions.TOGGLE,
        this.updatedRiskManagerDetails[reviewerIndex].reviewerRoleId
      );
    }
  }

  #updateReviewers(actionPerfomed: string, roleId: number) {
    this.progressIndicator.show();

    // Empty placeholder for RM, Supporting/Specialised RM are removed here.
    // As we check for emailId, fullName or displayName
    const reviewerSet = new Set();
    let updatedArr = structuredClone(this.updatedRiskManagerDetails);
    updatedArr = updatedArr
      .filter(
        (reviewer) =>
          reviewer.emailId || reviewer.fullName || reviewer.displayName
      )
      // TODO: May need to change the logic as we can add multiple specialized/supporting RM
      // Filtering and adding in set to avoid data duplication based on emailid
      .filter((reviewer) => {
        const identifier = `${reviewer.emailId?.toLowerCase()}`;
        if (reviewerSet.has(identifier)) {
          return false;
        } else {
          reviewerSet.add(identifier);
          return true;
        }
      });

    updatedArr.forEach((reviewer) => {
      delete reviewer.isEditing;
      delete reviewer.isEditable;
      delete reviewer.isForTechnicalReviewer;
    });

    // For TechnicalRM/reviewer add/remove toast msg
    const toastTitle: string =
      (roleId === RoleIdMapper[RoleEnum.TECHNICAL_INDEPENDENT_RISK_MANAGER] ||
        roleId === RoleIdMapper[RoleEnum.REVIEWER]) &&
      (actionPerfomed === UpdateReviewerActions.ADD ||
        actionPerfomed === UpdateReviewerActions.DELETE)
        ? `Reviewer ${
            actionPerfomed === UpdateReviewerActions.ADD ? 'added' : 'removed'
          }`
        : '';

    this.submissionService
      .updateSubmissionReviewers(updatedArr, Number(this.submissionId))
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (response: any) => {
          // do operation post updating the reviewers details
          if (response?.isSuccess) {
            if (toastTitle) {
              this.sharedService.showToastNotification(toastTitle);
            }
            this.submissionService
              .getSubmissionReviewers(this.submissionId.toString())
              .subscribe((response: SubmissionApprovers[]) => {
                this.setWorkflowReviewersDetails(response);
                this.checkValidation();
                this.checkButtonVisibility();
                this.disableAddReviewerButton = false;

                this.progressIndicator.hide();
              });
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('Error updating submission', err);
          this.progressIndicator.hide();
          this.disableAddReviewerButton = false;
        },
      });
  }

  addReviewer(roleName: string): void {
    // TODO: We can update the condition to use isAddReviewerButtonDisabled getter function

    // TODO: For adding a technicalreviewer do we need to check access for 'AddReviewer'?
    if (
      this.checkUserAccess('AddReviewer') && // TODO: Check the role to add technical reviewer
      !this.disableFieldOnComplete() &&
      !this.isWorkflowDisabled() &&
      ((roleName === this.roleAdditionalReviewer &&
        !this.disableAddReviewerButton) ||
        roleName !== this.roleAdditionalReviewer) &&
      // For checking permission - true if other than Technical RM or Technical RM with permission
      (roleName !== this.roleTechnicalOrIndependentRM ||
        (roleName === this.roleTechnicalOrIndependentRM &&
          // We only have Workflow.AddTechnicalReviewer.Enable'] which we were using previously.
          this.permissionObj['Intake_Workflow_Technical_Enable']))
    ) {
      const newReviewer: SubmissionApprovers = {
        submissionApproverId: 0, // 0 indicates a new reviewer to be saved
        reviewerId: randomString(20), // Unique identifier
        displayName: this._EMPTY,
        fullName: this._EMPTY,
        emailId: this._EMPTY,
        location: this._EMPTY,
        reviewerRoleId: this.roleIdMapper?.[roleName], // Assign and increment reviewerRoleId
        isRequired: false, // Assuming all additional reviewers are required; adjust as needed
        roleName: roleName,
        isEditing: true, // Start in editing mode to show People Picker,
        isEditable: true,
        isForTechnicalReviewer: roleName === this.roleTechnicalOrIndependentRM,
        submissionApproverStatus: null,
        submissionApproverDocumentId: null,
        statusReviewedDate: null,
      };

      let addReviewerPresent;
      if (roleName === this.roleAdditionalReviewer) {
        // Only checking for reviewer role  as technical check is present at caller function
        addReviewerPresent = this.updatedRiskManagerDetails.some(
          (reviewer) =>
            reviewer.roleName === this.roleAdditionalReviewer &&
            reviewer.submissionApproverId === 0
        );
      }
      if (!addReviewerPresent) {
        this.updatedRiskManagerDetails.push(newReviewer);
        this.tempUpdatedRiskManagerDetails = structuredClone(
          this.updatedRiskManagerDetails
        );
        if (roleName === this.roleAdditionalReviewer) {
          this.disableAddReviewerButton = true;
        }
      }
    }
  }

  onMemberSelected(
    reviewerEmail: string,
    reviewerId: number | string,
    member: any
  ): void {
    let reviewerIndex = -1;

    if (
      reviewerId &&
      reviewerId != undefined &&
      reviewerId != null &&
      reviewerId != this._EMPTY
    ) {
      reviewerIndex = this.updatedRiskManagerDetails.findIndex(
        (r) => r.reviewerId === reviewerId
      );
    } else {
      reviewerIndex = this.updatedRiskManagerDetails.findIndex(
        (r) => r.emailId === reviewerEmail
      );
    }
    if (reviewerIndex > -1) {
      this.updatedRiskManagerDetails[reviewerIndex].isEditing = false;
      this.updatedRiskManagerDetails[reviewerIndex].displayName =
        member.displayName;
      this.updatedRiskManagerDetails[reviewerIndex].fullName = member.fullname;
      this.updatedRiskManagerDetails[reviewerIndex].emailId = member.email;
      this.updatedRiskManagerDetails[reviewerIndex].location = member.location;
      this.updatedRiskManagerDetails[reviewerIndex].reviewerId =
        member?.reviewerId ?? this._EMPTY;
      this.updatedRiskManagerDetails[reviewerIndex].isBackUpRM = false;

      this.tempUpdatedRiskManagerDetails = structuredClone(
        this.updatedRiskManagerDetails
      );

      this.#updateReviewers(
        UpdateReviewerActions.ADD,
        this.updatedRiskManagerDetails[reviewerIndex].reviewerRoleId
      );
    }
  }

  editReviewer(
    reviewerEmailId: string,
    submissionApproverId: number,
    isTechnicalReviewer: boolean
  ): void {
    if (
      // Check if the workflow is not disabled and the "Add Reviewer" button is not disabled
      // and technicalreviewer has permission
      !this.isWorkflowDisabled() &&
      !this.disableAddReviewerButton &&
      ((!isTechnicalReviewer &&
        this.permissionObj['Intake_Submission_WorkflowAddReviewer_Enable']) ||
        (isTechnicalReviewer &&
          this.permissionObj['Intake_Workflow_Technical_Enable']))
    ) {
      let editReviewerIndex = this.updatedRiskManagerDetails.findIndex(
        (reviewer) => reviewer.emailId && reviewer.emailId === reviewerEmailId
      );
      // If email not present in the list, then check with submissionApproverId if present
      if (editReviewerIndex < 0 && submissionApproverId > -1) {
        editReviewerIndex = this.updatedRiskManagerDetails.findIndex(
          (reviewer) =>
            reviewer.submissionApproverId &&
            reviewer.submissionApproverId === submissionApproverId
        );
      }
      if (editReviewerIndex > -1) {
        this.disableAddReviewerButton = true;

        this.updatedRiskManagerDetails[editReviewerIndex].isEditing = true;
        this.updatedRiskManagerDetails[editReviewerIndex].displayName =
          this._EMPTY;
        this.updatedRiskManagerDetails[editReviewerIndex].fullName =
          this._EMPTY;
        this.updatedRiskManagerDetails[editReviewerIndex].emailId = this._EMPTY;
        this.updatedRiskManagerDetails[editReviewerIndex].location =
          this._EMPTY;
        this.updatedRiskManagerDetails[editReviewerIndex].reviewerId =
          randomString(20);
      }
    }
  }

  //save on clicking outside of the input box
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (this.isEditingTitle && !target.closest('#title-editor')) {
      this.saveTitle();
    }

    this.updatedRiskManagerDetails.forEach((reviewer, index) => {
      if (
        reviewer.isEditable &&
        reviewer.isEditing &&
        !target.closest(`#picker-${index}`)
      ) {
        // Resetting to the state before editing

        if (reviewer.submissionApproverId !== 0) {
          reviewer.displayName =
            this.tempUpdatedRiskManagerDetails[index].displayName;
          reviewer.fullName =
            this.tempUpdatedRiskManagerDetails[index].fullName;
          reviewer.emailId = this.tempUpdatedRiskManagerDetails[index].emailId;
          reviewer.location =
            this.tempUpdatedRiskManagerDetails[index].location;
          reviewer.reviewerId =
            this.tempUpdatedRiskManagerDetails[index].reviewerId;

          reviewer.isEditing = false;
          this.disableAddReviewerButton = false;
        } else if (
          reviewer.submissionApproverId === 0 &&
          reviewer.roleName !== this.roleTechnicalOrIndependentRM
        ) {
          this.updatedRiskManagerDetails.splice(index, 1);
          this.tempUpdatedRiskManagerDetails = structuredClone(
            this.updatedRiskManagerDetails
          );

          reviewer.isEditing = false;
          this.disableAddReviewerButton = false;
        }
      }
    });
  }

  //initiate title editing
  editTitle(): void {
    this.isEditingTitle = true;
    this.model.submissionTitle = this.commonHelperService.trimPrefixEmptySpace(
      this.titleValue
    );
  }

  //save the title and update header
  saveTitle(): void {
    this.titleValue = this.model.submissionTitle;
    this.isEditingTitle = false;
    this.updateTitle.emit({
      submissionId: this.dataSubmissionId,
      updatedTitle: this.titleValue,
    });
  }

  //copy the ID to clipboard
  copyToClipboard(value: string | null): void {
    if (value) {
      copyToClipboard(value);
    }
  }

  loadSubmission(isLoaderShow: boolean = true): void {
    if (isLoaderShow) {
      this.progressIndicator.show();
    }
    const submissionId: string =
      this.dataSubmissionId !== null
        ? this.dataSubmissionId.toString()
        : this._EMPTY;
    this.employeeIdNumber = Number(this.submissionService.employeeId);
    this.SubmissionActionHistoryForAdminComplete(submissionId);
    this.submissionService.changeSubmissionId({
      opportunitynumber: this.dataOpportunityId,
      submissionid: this.dataSubmissionId,
    });
    if (submissionId !== this._EMPTY) {
      document.title =
        BrowserTabConstant.Browser_TabName_Default + submissionId;
      this.isOpportunitySelected = false;
      this.updatedRiskManagerDetails = [];
      this.tempUpdatedRiskManagerDetails = [];
      this.selectedRiskManagers = [];
      this.coHasParentOpportunityNumber = false;
      forkJoin([
        this.submissionService.getSubmissionBySubmissionId(
          this.dataOpportunityId,
          submissionId
        ),
        this.submissionService.getSubmissionReviewers(submissionId),
      ])
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe({
          next: (response: any) => {
            const submissionDetails = response[0];
            const reviewerDetailsFromReviewerApi = response[1];
            const nullCount = reviewerDetailsFromReviewerApi.filter(
              (item: any) => item.statusReviewedDate === null
            ).length;
            if (nullCount === 1) {
              this.toastOptions.title =
                this.configData.find(
                  (config: configurationType) =>
                    config.appConfigurationLabelKey ===
                    IntakeConstant.COMPLETE_REVIEW_TOAST_TITLE_LAST_REVIEWER
                )?.appConfigurationLabelValue || this._EMPTY;
              this.toastOptions.message =
                this.configData.find(
                  (config: configurationType) =>
                    config.appConfigurationLabelKey ===
                    IntakeConstant.COMPLETE_REVIEW_TOAST_LAST_REVIEWER
                )?.appConfigurationLabelValue || this._EMPTY;
            } else if (nullCount > 1) {
              this.toastOptions.title =
                this.configData.find(
                  (config: configurationType) =>
                    config.appConfigurationLabelKey ===
                    IntakeConstant.COMPLETE_REVIEW_TOAST_TITLE
                )?.appConfigurationLabelValue || this._EMPTY;
              this.toastOptions.message =
                this.configData.find(
                  (config: configurationType) =>
                    config.appConfigurationLabelKey ===
                    IntakeConstant.COMPLETE_REVIEW_TOAST_MESSAGE
                )?.appConfigurationLabelValue || this._EMPTY;
            } else {
              this.toastOptions.title =
                this.configData.find(
                  (config: configurationType) =>
                    config.appConfigurationLabelKey ===
                    IntakeConstant.COMPLETE_REVIEW_TOAST_TITLE
                )?.appConfigurationLabelValue || this._EMPTY;
              this.toastOptions.message =
                this.configData.find(
                  (config: configurationType) =>
                    config.appConfigurationLabelKey ===
                    IntakeConstant.COMPLETE_REVIEW_TOAST_MESSAGE
                )?.appConfigurationLabelValue || this._EMPTY;
            }
            if (Object.keys(submissionDetails).length !== 0) {
              this.submissionData = { ...submissionDetails };
              this.submissionTypeId = Number(
                this.submissionData.submissionTypeId
              );
              this.submissionTypeSubId = Number(
                this.submissionData?.submissionSubTypeId
              );
              this.submissionStatusId = Number(
                this.submissionData.submissionStatusId
              );
              this.primaryDgmfId = this.submissionData?.dgmfId;
              this.primaryGmdmId = this.submissionData?.gmdmId;
              this.primarySwiftId = this.submissionData?.swiftId;
              this.pursuitLeaderId = this.submissionData?.pursuitLeaderId;
              this.pursuitLeaderName = this.submissionData?.pursuitLeaderName;
              this.isArchiveFeatureEnable =
                this.submissionData.isArchiveItIntegrationEnabled;
              this.titleValue = this.submissionData.submissionTitle;
              this.submissionId = this.submissionData.submissionId;
              this.lepAcknowledgedBy = this.submissionData.lepAcknowledgedBy;
              this.lepAcknowledgementDate =
                this.submissionData.lepAcknowledgementDate;
              this.lepReviewedBy = this.submissionData.lepReviewedBy;
              this.submissionStatus = this.submissionData.submissionStatusName;
              if (
                this.submissionData.submissionStatusName !==
                this.previousSubmissionStatus
              ) {
                this.updateLeftMenu.emit(this.opportunityNumber);
                this.previousSubmissionStatus =
                  this.submissionData.submissionStatusName ?? this._EMPTY;
              }
              this.model.reasonForResubmit =
                this.submissionData.reasonForResubmit;
              this.currentStatusChangeDate =
                this.submissionData.currentStatusChangeDate;
              this.model.isSuppressedReviewConfirmationNotification =
                this.submissionData.isSuppressedReviewConfirmationNotification;
              this.setWbsAndArchiveValues(this.submissionData);

              this.archiveDetails = {
                archiveName: this.model.archiveName,
                archiveNumber: this.isArchiveNotListed
                  ? IntakeConstant.ARCHIVE_NOT_LISTED
                  : this.model.archiveNumber,
                archiveDescription: this.isArchiveNotListed
                  ? IntakeConstant.ARCHIVE_NOT_LISTED
                  : this.model.archiveDescription,
              };

              this.swiftDetails = {
                projectName: this.submissionData.swiftDetails?.projectName,
                projectStartDate:
                  this.submissionData.swiftDetails?.projectStartDate,
                projectEndDate:
                  this.submissionData.swiftDetails?.projectEndDate,
                projectPPMD: this.submissionData.swiftDetails?.projectPPMD,
              };
              if (
                this.lepAcknowledgedBy === null &&
                this.lepAcknowledgementDate === null &&
                this.lepReviewedBy === null
              ) {
                this.showLepConfirmationMessage = true;
              } else {
                this.showLepConfirmationMessage = false;
              }

              if (this.submissionTypeCode === this.submissionTypeCodeOther) {
                this.model.submissionSubTypeId =
                  this.submissionData.submissionSubTypeId?.toString() ??
                  this._EMPTY;
              }

              if (this.submissionTypeCode === this.submissionTypeCodeCO) {
                this.checkCOhasParentOpportunityNoOrNot();
              }
              this.selfReviewAllOperationSet();
              this.submissionService.setSelectedOpportunityDocStatus(
                (this.submissionStatus as IntakeOppertunitySubmissionStatus) ??
                  null
              );

              this.selfReviewEligibility =
                this.submissionData.selfReviewEligibilityStatus;
              this.selfReviewEligibilityStatusId =
                this.submissionData.selfReviewEligibilityStatusId;
              this.optOutSelfReviewDate =
                this.submissionData.optOutSelfReviewDate;
              this.model.coChangeScope =
                IntakeConstant.BOOLEAN_CHECKBOX_VALUE_TO_YES_NO.get(
                  this.submissionData.coChangeScope
                );
              this.model.coDescription = this.submissionData.coDescription;
              this.model.submissionTitle =
                this.commonHelperService.trimPrefixEmptySpace(
                  this.submissionData.submissionTitle
                );
              this.model.otherDescription =
                this.submissionData.otherDescription;
              this.model.proposalDescription =
                this.submissionData.proposalDescription;
              this.model.relatedToRFP =
                IntakeConstant.BOOLEAN_CHECKBOX_VALUE_TO_YES_NO.get(
                  this.submissionData.relatedToRFP
                );
              this.model.delDescription = this.submissionData.delDescription;
              this.model.notesAndFeedback =
                this.submissionData.notesAndFeedback;
              this.model.internalQRMTeamCommunication =
                this.submissionData.internalQRMTeamCommunication;
              this.model.winningProposal = this.submissionData.winningProposal; // in v3 not used
              this.isEligibleTechnicalReviewer =
                this.submissionData.isEligibleTechnicalReviewer;

              this.reviewerDetailsFromReviewerApi =
                reviewerDetailsFromReviewerApi;
              this.setWorkflowReviewersDetails(
                this.reviewerDetailsFromReviewerApi
              );
              this.optOutOfSelfReviewReason =
                submissionDetails?.reasonForOptOutSelfReview;
              if (
                this.optOutOfSelfReviewReason &&
                this.submissionStatus === this.submissionStatusDraft
              ) {
                this.showSubmitBtnWhnDraft = true;
              } else {
                this.showSubmitBtnWhnDraft = false;
              }
              // TODO: Once Employee ID is implemented
              // this.checkActionsColumn();

              this.isEmployeePresent = this.updatedRiskManagerDetails.some(
                (employee: SubmissionApprovers) =>
                  Number(employee.reviewerId) === this.employeeIdNumber
              );

              this.submissionService.enableAdminComplete(
                this.isStatusSelfReviewedPendingCloseoutOrRmReviewedPendingCloseout()
              );
              this.commonService.enableResetStatus(
                this.showResetStatusDropdown()
              );
              this.submissionService.disableDocumentButtonOnAdminComplte(
                this.checkStatusCompletedByAdmin()
              );
            }
            if (
              this.submissionData.submissionTypeCode ===
                this.submissionTypeCodeCO ||
              this.submissionData.submissionTypeCode ===
                this.submissionTypeCodeOther
            ) {
              this.isOpporunityLevelFormCompleted = true;
            } else {
              this.isOpporunityLevelFormCompleted =
                this.submissionData.isOpportunityDetailsCompleted;
            }
            this.isSubmissionStatusRMorSelfReviewed =
              this.submissionStatus ===
                this.submissionStatusRMPendingCloseout ||
              this.submissionStatus ===
                this.submissionStatusSelfPendingCloseout ||
              this.submissionStatus ===
                this.submissionStatusIncompletePendingCloseout;
            this.isSubmissionStatusRMorSelfReviewed
              ? (this.collapseSelfReviewAccordion = false)
              : (this.collapseSelfReviewAccordion = true);

            if (
              this.submissionStatus ===
                this.submissionStatusSelfPendingCloseout ||
              this.submissionStatus ===
                this.submissionStatusIncompletePendingCloseout
            ) {
              this.swapReviewedDocResubmit = 'Resubmit';
              this.reviewDocSubmitTooltip =
                'Resubmit an updated document for risk management review';
              this.swapSectionOptions[0].heading = this.swapReviewedDocResubmit;
              this.swapSectionOptions[0].value = this.swapReviewedDocResubmit;
            } else if (
              this.submissionStatus === this.submissionStatusRMPendingCloseout
            ) {
              this.swapReviewedDocResubmit =
                'Access reviewed document(s) / Resubmit';
              this.reviewDocSubmitTooltip =
                'Access RM reviewed documents or resubmit an updated document for risk management review';

              this.swapSectionOptions[0].heading = this.swapReviewedDocResubmit;
              this.swapSectionOptions[0].value = this.swapReviewedDocResubmit;
            }

            this.checkButtonVisibility();
            this.progressIndicator.hide();
            this.isSubmissionDataLoading = false;
          },
          error: (err: HttpErrorResponse) => {
            this.progressIndicator.hide();
            console.error('Error fetching submission', err);
          },
        });
    } else {
      this.isOpportunitySelected = true;
    }
    if (isLoaderShow) {
      this.progressIndicator.hide();
    }
  }

  isProposalAccordionOpen(): boolean {
    return this.isAccordianOpenCommon();
  }

  isDeliverableAccordionOpen(): boolean {
    return this.isAccordianOpenCommon();
  }

  isOtherAccordionOpen(): boolean {
    return this.isAccordianOpenCommon();
  }

  isCOAccordionOpen(): boolean {
    return this.isAccordianOpenCommon();
  }

  isAccordianOpenCommon(): boolean {
    return (
      this.submissionStatus != this._EMPTY &&
      this.submissionStatus !== this.submissionStatusRMPendingCloseout &&
      this.submissionStatus !== this.submissionStatusSelfPendingCloseout &&
      this.submissionStatus !== this.submissionStatusIncompletePendingCloseout
    );
  }

  isAccordionVisible(
    submissionCodeType: IntakeDocumentSubmissionTypeCode
  ): boolean {
    return (
      this.submissionTypeCode != this._EMPTY &&
      this.submissionTypeCode === submissionCodeType
    );
  }

  proposalDescriptionValueChanged(): void {
    this.checkValidation();
  }

  RelatedtoRFPstateChanged(): void {
    this.checkValidation();
  }

  deliverableDescValueChanged(): void {
    this.checkValidation();
  }

  internalQrmCommunicationInputValueChanged(): void {}
  feedbackInputValueChanged(): void {}
  OtherDescriptionValueChanged(): void {
    this.checkValidation();
  }

  stateHandling(): void {
    this.apiCallHandling = true;
  }

  COChangeScopeStateChanged(): void {
    if (this.submissionTypeCode === this.submissionTypeCodeCO) {
      this.checkValidation();
    }
    this.submissionService
      .getSubmissionBySubmissionId(
        this.dataOpportunityId,
        this.submissionId.toString()
      )
      .subscribe({
        next: (
          response: IntakeSubmissionDetailsCommonSectionDataReceivedModal
        ) => {
          this.submissionData = { ...response };
          this.selfReviewEligibility =
            this.submissionData.selfReviewEligibilityStatus;
          this.isSelfReviewButtonVisible =
            this.selfReviewEligibility == 'Yes' ? true : false;
        },
        error: (err: HttpErrorResponse) => {
          console.error('Error fetching submission', err);
        },
      });
  }

  CODescriptionValueChanged(): void {
    this.checkValidation();
  }

  clickToShowDocumentMoreLepMessage(): void {
    this.isShowMoreDocumentNotes = !this.isShowMoreDocumentNotes;
    if (!this.isShowMoreDocumentNotes) {
      this.showMoreText = IntakeConstant.SHOW_MORE_TEXT;
      this.showMoreOptions.icon = IntakeConstant.DDS_ICON_ARROW_DOWN;
    } else {
      this.showMoreText = IntakeConstant.SHOW_LESS_TEXT;
      this.showMoreOptions.icon = IntakeConstant.DDS_ICON_ARROW_UP;
    }
  }

  checkCOhasParentOpportunityNoOrNot(): void {
    this.submissionService
      .getOpportunitySelected(this.dataOpportunityId)
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (data: latestOpportunityDetails) => {
          this.coHasParentOpportunityNumber =
            (data?.parentOpportunityNumber == null ||
              data?.parentOpportunityNumber == this._EMPTY) &&
            this.opportunityDocsCount === 1;
          this.isCheckboxCheckedForNoEL_SOW = this.coHasParentOpportunityNumber;
        },
        error: (err: HttpErrorResponse) => {
          console.error('Error fetching submission', err);
        },
      });
  }

  handleCompleteReviewFromHeader(): void {
    const data: SubmissionApprovers | undefined =
      this.updatedRiskManagerDetails.find(
        (item) => item.reviewerId === this.currentLoggedInUser
      );
    if (data) this.handleCompleteReview(data);
  }

  handleReturnForReworkFromHeader(): void {
    this.handleReturnforRework({} as SubmissionApprovers);
  }

  handleCompleteReview(data: SubmissionApprovers): void {
    const allDocumentsReviewed = this.documentTableData.some(
      (doc) => doc.documentStatus === 'RM Reviewed'
    );
    const requiredReviewers = this.updatedRiskManagerDetails.filter(
      (reviewer: SubmissionApprovers) => reviewer.isRequired
    );
    const pendingReviewers = requiredReviewers.filter(
      (reviewer) => !reviewer.statusReviewedDate
    ).length;
    if (
      pendingReviewers > 1 ||
      (pendingReviewers === 1 && allDocumentsReviewed)
    ) {
      this.updateRMStatusHandler(data);
    } else if (pendingReviewers === 1 && !allDocumentsReviewed) {
      this.openModal(data);
    }
  }

  updateRMStatusHandler(data: SubmissionApprovers): void {
    const saveSelectedDocuments: IntakeSubmissionDeatilsCommonSectionWorkflowSelectedDocumentsModal =
      {
        SubmissionDocumentId: [],
        RMEmployeeid: data.reviewerId,
        Email: data.emailId,
        SubmissionId: +this.submissionId,
        DocumentStatusId: 2,
        SubmissionTypeId: this.submissionTypeId,
      };
    this.progressIndicator.show();
    this.submissionService
      .updateRMStatus(saveSelectedDocuments)
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: () => {
          this.progressIndicator.hide();
          this.documentComponent.triggerDocumentTableDataApi();
          this.sharedService.showToastNotification(this.toastOptions.title ?? '', false, this.toastOptions.message ?? '');
          this.router.navigate(['/']);
        },
        error: (err: HttpErrorResponse) => {
          this.progressIndicator.hide();
          console.error('An error occurred while sending the data ', err);
        },
      });
  }

  handleReturnforRework(data: SubmissionApprovers): void {
    const submissionStatusId = this.getSubmissionStatusCode(
      this.submissionStatusReturnForRework
    );
    if (submissionStatusId) {
      this.progressIndicator.show();
      this.submissionService
        .submitCommonSectionData(this.submissionId, submissionStatusId)
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe({
          next: (response: string) => {
            this.progressIndicator.hide();
            this.submissionStatusCommonSection = response;
            //  this.documentComponent.triggerDocumentTableDataApi(); // TODO: Remove, Since navigating to dashboard we dont need to call
            this.sharedService.showToastNotification('Returned for revisions');
            this.router.navigate(['/']);
          },
          error: (err: HttpErrorResponse) => {
            this.progressIndicator.hide();
            console.error('An error occurred during submission: ', err);
          },
        });
    }
  }

  resubmitCommonSectionData(): void {
    if (this.permissionObj['Intake_Submission_ReSubmitBtn_Enable']) {
      const submissionStatusId = this.getSubmissionStatusCode(
        this.submissionStatusResubmitted
      );
      if (submissionStatusId) {
        this.progressIndicator.show();
        this.submissionService
          .submitCommonSectionData(this.submissionId, submissionStatusId)
          .pipe(takeUntil(this.#unsubscriber$))
          .subscribe({
            next: (response: string) => {
              this.submissionStatusCommonSection = response;
              this.progressIndicator.hide();
              const rmSupport = this.updatedRiskManagerDetails.find(
                (reviewer) => reviewer.roleName === this.roleRiskManager
              );
              if (
                rmSupport &&
                (rmSupport.displayName !== this._EMPTY ||
                  rmSupport.fullName !== this._EMPTY) &&
                this.selfReviewEligibility !== IntakeConstant.YES
              ) {
                this.sharedService.showToastNotification('Re-submitted');
              } else if (
                this.selfReviewEligibility !== IntakeConstant.YES &&
                (rmSupport?.displayName === this._EMPTY ||
                  rmSupport?.fullName === this._EMPTY)
              ) {
                this.sharedService.showToastNotification(
                  'Your request is saved in the system.',
                  false,
                  this.withoutRMToastOptionMessage
                );
              }
              this.documentComponent.triggerDocumentTableDataApi();
              this.router.navigate(['/']);
            },
            error: (err: HttpErrorResponse) => {
              console.error('An error occurred during submission: ', err);
              this.progressIndicator.hide();
            },
          });
      }
    }
  }

  openModal(rowDetails: SubmissionApprovers): void {
    const prescreenConfirmModalRef = this.modalService.open(
      DocumentSelectionPopupComponent,
      {
        submissionID: this.submissionId,
        rowDetails: rowDetails,
        submissionTypeId: this.submissionTypeId,
      }
    );
    prescreenConfirmModalRef
      .onClosed()
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (showToastMessage: boolean) => {
          if (this.submissionId && showToastMessage) {
            this.documentComponent.triggerDocumentTableDataApi();
            if (showToastMessage) {
              this.sharedService.showToastNotification(this.toastOptions.title ?? '', false, this.toastOptions.message ?? '');
              this.router.navigate(['/']);
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('An error occurred during opening modal: ', err);
        },
      });
  }

  setWorkflowReviewersDetails(
    reviewerDetailsFromGetReviewerApi: SubmissionApprovers[]
  ): void {
    this.updatedRiskManagerDetails = [];
    this.tempUpdatedRiskManagerDetails = [];
    this.selectedRiskManagers = [];
    const reviewerDetails = reviewerDetailsFromGetReviewerApi;

    const addPlaceholder = (roleName: string) => {
      const newReviewer: SubmissionApprovers = {
        submissionApproverId: 0, // 0 indicates a new reviewer to be saved
        reviewerId: randomString(20), // Unique identifier
        displayName: this._EMPTY,
        fullName: this._EMPTY,
        emailId: this._EMPTY,
        location: this._EMPTY,
        reviewerRoleId: this.roleIdMapper?.[roleName], // Assign and increment reviewerRoleId
        isRequired: false,
        roleName: roleName,
        isEditing: false,
        isEditable: false,
        isForTechnicalReviewer: roleName === this.roleTechnicalOrIndependentRM,
        submissionApproverStatus: null,
        submissionApproverDocumentId: null,
        statusReviewedDate: null,
      };
      this.updatedRiskManagerDetails.push(newReviewer);
    };

    // Empty placeholder are removed in updatereviewer()
    this.showRiskManagerLabel = !reviewerDetails.some(
      (reviewer) => reviewer.roleName === this.roleRiskManager
    );
    if (this.showRiskManagerLabel) addPlaceholder(this.roleRiskManager);

    this.showSupportingRiskManagerLabel = !reviewerDetails.some(
      (reviewer) => reviewer.roleName === this.roleSupportingRiskManager
    );
    if (this.showSupportingRiskManagerLabel)
      addPlaceholder(this.roleSupportingRiskManager);

    this.showSpecializedRiskManagerLabel = !reviewerDetails.some(
      (reviewer) => reviewer.roleName === this.roleSpecializedRiskManager
    );
    if (this.showSpecializedRiskManagerLabel)
      addPlaceholder(this.roleSpecializedRiskManager);

    reviewerDetails.forEach((element) => {
      const findUserDetailsFromReviewerApi: SubmissionApprovers[] =
        this.findUserByEmailFromResponse(element.emailId);

      if (element.isRequired) {
        this.pushInSelectedRiskManagers(element.emailId);
      }

      const existingReviewerIndex = this.updatedRiskManagerDetails.findIndex(
        (reviewer: SubmissionApprovers) => reviewer.emailId === element.emailId
      );

      // If reviewer is not present in the list, then add it
      // TODO: Remove commented code after testing is successful
      if (
        existingReviewerIndex === -1
        // &&
        // (element.roleName !== this.roleTechnicalOrIndependentRM ||
        //   (element.roleName === this.roleTechnicalOrIndependentRM &&
        //     this.permissionObj['Intake_Workflow_Technical_Enable']))
      ) {
        this.updatedRiskManagerDetails.push({
          ...element,
          isRequired: element.isRequired ?? false,
          reviewerId: this.getReviewerId(
            element.reviewerId,
            findUserDetailsFromReviewerApi[0]?.reviewerId
          ),
          isEditing: false,
          isEditable:
            element.roleName === this.roleRiskManager ||
            element.roleName === this.roleSupportingRiskManager ||
            element.roleName === this.roleSpecializedRiskManager
              ? false
              : true,
          isForTechnicalReviewer:
            element.roleName === this.roleTechnicalOrIndependentRM,
        });
      }
    });

    const technicalPresent = this.updatedRiskManagerDetails.some(
      (reviewer) => reviewer.roleName === this.roleTechnicalOrIndependentRM
    );

    if (this.isEligibleTechnicalReviewer && !technicalPresent) {
      this.addReviewer(this.roleTechnicalOrIndependentRM);
    }

    this.sortInOrderReviewerTable();

    this.tempUpdatedRiskManagerDetails = structuredClone(
      this.updatedRiskManagerDetails
    );
  }

  sortInOrderReviewerTable(): void {
    // Sorting the reviewers based on the specified order
    const rolesOrder = [
      this.roleRiskManager,
      this.roleSupportingRiskManager,
      this.roleSpecializedRiskManager,
      this.roleTechnicalOrIndependentRM,
    ];

    const updatedReviewerList = rolesOrder.flatMap((role: string) =>
      this.updatedRiskManagerDetails.filter(
        (reviewer: SubmissionApprovers) => reviewer.roleName === role
      )
    );

    const remainingReviewers: SubmissionApprovers[] =
      this.updatedRiskManagerDetails.filter(
        (reviewer: SubmissionApprovers) =>
          reviewer.roleName !== null && !rolesOrder.includes(reviewer.roleName)
      );

    this.updatedRiskManagerDetails = [
      ...updatedReviewerList,
      ...remainingReviewers.sort(
        (reviewer1: SubmissionApprovers, reviewer2: SubmissionApprovers) =>
          (reviewer1.submissionApproverId ?? 0) -
          (reviewer2.submissionApproverId ?? 0)
      ),
    ];
  }

  pushInSelectedRiskManagers(emailId: string): void {
    if (!this.selectedRiskManagers.includes(emailId)) {
      this.selectedRiskManagers.push(emailId);
    }
  }

  getReviewerId(
    reviewerIdFromGetReviewerApi: string | number,
    reviewerIdFromGetSubmissionApi: string | number
  ): string | number {
    if (
      reviewerIdFromGetReviewerApi &&
      reviewerIdFromGetReviewerApi != null &&
      reviewerIdFromGetReviewerApi != this._EMPTY
    ) {
      return reviewerIdFromGetReviewerApi;
    } else if (
      reviewerIdFromGetSubmissionApi &&
      reviewerIdFromGetSubmissionApi != null &&
      reviewerIdFromGetSubmissionApi != this._EMPTY
    ) {
      return reviewerIdFromGetSubmissionApi;
    } else {
      return this._EMPTY;
    }
  }

  // TODO: Remove if it's not necessary - As we have updated hte apis
  findUserByEmailFromResponse(reviewerMaiId: string): SubmissionApprovers[] {
    const submissionReviewerFromReviewersApi = [
      ...this.reviewerDetailsFromReviewerApi,
    ];
    let submissionReviewer = submissionReviewerFromReviewersApi.filter(
      (user: SubmissionApprovers) => user.emailId === reviewerMaiId
    );
    return submissionReviewer.length > 0 ? submissionReviewer : [];
  }

  handleLEPCompletion(): void {
    if (this.permissionObj['Intake_Submission_LEPConfirmation_Enable']) {
      this.progressIndicator.show();
      this.submissionService
        .putLepStatus(
          this.dataSubmissionId,
          this.currentLoggedInUser,
          this.submissionData.pursuitLeaderId ?? this.dataLepValue.lepReviewedBy
        )
        .subscribe(() => {
          this.progressIndicator.hide();
          this.loadSubmission();
        });
    }
  }

  getLabelConfiguration(): void {
    this.submissionService
      .getIntakeConfigurations()
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (response: configurationType[]) => {
          if (response) {
            this.configData = response;
            this.withoutRMToastOptionMessage =
              this.configData.find(
                (config: configurationType) =>
                  config.appConfigurationLabelKey ===
                  'RiskManagerAssignmentDelay'
              )?.appConfigurationLabelValue || this._EMPTY;
            this.UPLOAD_DOCUMENTS_LABEL_DRAFT =
              this.configData.find(
                (config: configurationType) =>
                  config.appConfigurationLabelKey === 'UPLOAD_DOCUMENTS'
              )?.appConfigurationLabelValue || this._EMPTY;

            this.UPLOAD_DOCUMENTS_LABEL_DRAFT_EL_SOW =
              this.configData.find(
                (config: configurationType) =>
                  config.appConfigurationLabelKey === 'UPLOAD_DOCUMENTS_EL_SOW'
              )?.appConfigurationLabelValue || this._EMPTY;

            if (this.submissionTypeCode === this.submissionTypeCodeCO) {
              if (isTheDocumentHasCompletedElSOw(this.opportunityDocs)) {
                this.configLableDocument = this.UPLOAD_DOCUMENTS_LABEL_DRAFT;
              } else {
                this.configLableDocument =
                  this.configData.find(
                    (config: configurationType) =>
                      config.appConfigurationLabelKey === 'UPLOAD_CO_DOCUMENTS'
                  )?.appConfigurationLabelValue || this._EMPTY;
              }

              this.coOppDonotMatchMessage =
                this.configData.find(
                  (config: configurationType) =>
                    config.appConfigurationLabelKey ===
                    IntakeConstant.CO_OPP_DONOT_MATCH
                )?.appConfigurationLabelValue || this._EMPTY;
            } else if (
              this.submissionTypeCode == this.submissionTypeCodeELSOW
            ) {
              this.configLableDocument =
                this.UPLOAD_DOCUMENTS_LABEL_DRAFT_EL_SOW;
            } else {
              this.configLableDocument =
                this.submissionTypeCode == this.submissionTypeCodeOther &&
                this.dataSubmissionSubTypeCode != null &&
                this.dataSubmissionSubTypeCode ==
                  3 /*Subcontractor Agreement (Subcon) */
                  ? IntakeConstant.SUBCONTRACTOR_DOC_GUIDANCE_LABEL
                  : this.UPLOAD_DOCUMENTS_LABEL_DRAFT;
            }

            this.rmReviewedGuidanceNoteHeader =
              this.configData.find(
                (config: configurationType) =>
                  config.appConfigurationLabelKey ===
                  IntakeConstant.RM_REVIEWED_GUIDANCE_NOTE_HEADER
              )?.appConfigurationLabelValue || this._EMPTY;

            this.rmReviewedGuidanceNoteBody =
              this.configData.find(
                (config: configurationType) =>
                  config.appConfigurationLabelKey ===
                  IntakeConstant.RM_REVIEWED_GUIDANCE_NOTE_BODY
              )?.appConfigurationLabelValue || this._EMPTY;
            this.submittedToastOptionTitle =
              this.configData.find(
                (config: configurationType) =>
                  config.appConfigurationLabelKey ===
                  IntakeConstant.SUBMITTED_TOAST_TITLE
              )?.appConfigurationLabelValue || this._EMPTY;

            // this.submittedToastOption.title =
            //   this.configData.find(
            //     (config: configurationType) =>
            //       config.appConfigurationLabelKey ===
            //       IntakeConstant.SUBMITTED_TOAST_TITLE
            //   )?.appConfigurationLabelValue || this._EMPTY;

            this.submittedToastOptionMessage =
              this.configData.find(
                (config: configurationType) =>
                  config.appConfigurationLabelKey ===
                  IntakeConstant.SUBMITTED_TOAST_MESSAGE
              )?.appConfigurationLabelValue || this._EMPTY;
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('An error occurred during submission: ', err);
        },
      });
  }

  updateSubmitButtonStatus(): boolean {
    if (
      (this.changeOrderStatus &&
        this.co_draft_Document_Uploaded &&
        this.model.coChangeScope &&
        this.model.coDescription &&
        !this.showLepConfirmationMessage) ||
      (this.submissionTypeCode === this.submissionTypeCodeCO &&
        this.model.coChangeScope &&
        this.model.coDescription &&
        this.isValidDocumentUploaded &&
        this.co_draft_Document_Uploaded &&
        !this.showLepConfirmationMessage) ||
      (this.submissionTypeCode === this.submissionTypeCodeDelivery &&
        this.model.delDescription &&
        this.isValidDocumentUploaded &&
        !this.showLepConfirmationMessage) ||
      (this.isValidDocumentUploaded &&
        this.model.otherDescription &&
        this.model.submissionSubTypeId &&
        this.submissionTypeCode === this.submissionTypeCodeOther &&
        !this.showLepConfirmationMessage) ||
      (this.isValidDocumentUploaded &&
        this.model.relatedToRFP &&
        ((this.model.relatedToRFP === IntakeConstant.NO.toLowerCase() &&
          this.hasProposalTypeDoc) ||
          (this.hasRFP &&
            this.model.relatedToRFP === IntakeConstant.YES.toLowerCase())) &&
        !this.showLepConfirmationMessage) ||
      (this.isValidDocumentUploaded &&
        this.submissionTypeCode === this.submissionTypeCodeELSOW &&
        !this.showLepConfirmationMessage)
    ) {
      return false;
    }
    return true;
  }

  submitCommonSectionData(statusCode: IntakeOppertunitySubmissionStatus): void {
    const submittedubmissionStatusID = this.getSubmissionStatusCode(statusCode);
    const IsValidArchive = this.model.archiveStatus
      ? IntakeConstant.VALID_ARCHIVE_LIST.includes(this.model.archiveStatus)
      : false;
    if (submittedubmissionStatusID) {
      this.progressIndicator.show();

      this.submissionService
        .submitCommonSectionData(
          this.submissionId,
          submittedubmissionStatusID,
          this.submissionTypeId,
          IsValidArchive
        )
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe({
          next: (response: string) => {
            this.progressIndicator.hide();
            this.submissionStatusCommonSection = response;
            if (response) {
              this.updateAfterSubmit(true);
            }
          },
          error: (error: HttpErrorResponse) => {
            this.progressIndicator.hide();
            this.updateAfterSubmit(false);
            console.error('An error occurred during submission: ', error);
          },
        });
    }
  }

  updateAfterSubmit(navigate: boolean): void {
    const rmSupport = this.updatedRiskManagerDetails.find(
      (reviewer) => reviewer.roleName === this.roleRiskManager
    );
    if (
      rmSupport &&
      (rmSupport.displayName !== this._EMPTY ||
        rmSupport.fullName !== this._EMPTY) &&
      this.selfReviewEligibility !== 'Yes'
    ) {
      this.sharedService.showToastNotification(
        this.submittedToastOptionTitle,
        false,
        this.submittedToastOptionMessage
      );
    } else {
      this.configData = this.configData.filter(
        (config: configurationType) =>
          config.appConfigurationLabelKey !== 'RiskManagerAssignmentDelay'
      );
      if (this.selfReviewEligibility !== IntakeConstant.YES) {
        this.sharedService.showToastNotification(
          'Your request is saved in the system.',
          false,
          this.withoutRMToastOptionMessage
        );
      } else {
        this.router.navigate(['/']);
      }
    }
    if (navigate && this.selfReviewEligibility !== IntakeConstant.YES) {
      this.router.navigate(['/']);
    } else {
      this.loadSubmission();
      this.updateLeftMenu.emit(this.opportunityNumber);
    }
  }

  isSubmitBtnVisible(): boolean {
    return (
      this.permissionObj['Intake_Submission_SubmitBtn_Visible'] &&
      ((this.submissionStatus === this.submissionStatusDraft &&
        this.selfReviewEligibility != IntakeConstant.YES) ||
        this.showSubmitBtnWhnDraft)
    );
  }

  isResubmitBtnVisible(): boolean {
    return (
      this.permissionObj['Intake_Submission_ReSubmitBtn_Visible'] &&
      this.submissionStatus === this.submissionStatusReturnForRework
    );
  }

  isArchiveAndCompleteBtnVisible(): boolean {
    return (
      this.permissionObj['Intake_Submission_ArchiveAndCompleteBtn_Visible'] &&
      this.isStatusPendingCloseout() &&
      this.selectedSwapAction === this.swapArchiveFinalize
    );
  }

  isStatusSelfReviewedPendingCloseoutOrRmReviewedPendingCloseout(): boolean {
    return (
      this.isSelfReviewPendingCloseout() || this.isRMReviewPendingCloseout()
    );
  }

  isStatusPendingCloseout(): boolean {
    return (
      this.submissionStatus ===
        this.submissionStatusIncompletePendingCloseout ||
      this.isStatusSelfReviewedPendingCloseoutOrRmReviewedPendingCloseout()
    );
  }

  isSelfReviewPendingCloseout(): boolean {
    return this.submissionStatus === this.submissionStatusSelfPendingCloseout;
  }

  isRMReviewPendingCloseout(): boolean {
    return this.submissionStatus === this.submissionStatusRMPendingCloseout;
  }

  showResetStatusDropdown(): boolean {
    return (
      this.isSubmissionInReadOnlyStatus() ||
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.DISCONTINUED ||
      this.submissionStatus === IntakeOppertunitySubmissionStatus.DRAFT ||
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.RETURN_FOR_REWORK ||
      this.submissionStatus === IntakeOppertunitySubmissionStatus.RESUBMITTED ||
      this.submissionStatus === IntakeOppertunitySubmissionStatus.SUBMITTED
    );
  }

  onclickArchiveAndCompleteBtn(): void {
    if (this.permissionObj['Intake_Submission_ArchiveAndCompleteBtn_Enable']) {
      const submissionStatusId = this.getSubmissionStatusCode(
        IntakeOppertunitySubmissionStatus.COMPLETED
      );
      const IsValidArchive = IntakeConstant.VALID_ARCHIVE_LIST.includes(
        this.model.archiveStatus ? this.model.archiveStatus : ''
      );
      this.progressIndicator.show();
      // **********************commented bcz achive feature is happening in backend - future this can remove this commented block dated: 22-april-2025
      // if (
      //   this.isArchiveFeatureEnable &&
      //   this.archiveNumberSelected != IntakeConstant.EMPTY_SPACE &&
      //   this.archiveNumberSelected != null &&
      //   this.archiveNumberSelected != undefined &&
      //   this.archiveNumberSelected != IntakeConstant.ARCHIVE_NOT_LISTED
      // ) {
      //   const EntityTypeId = 1; // 1for intake
      //   this.documentService
      //     .generateArchiveSubmissionPDF(
      //       this.submissionId,
      //       this.opportunityNumber
      //     )
      //     .pipe(takeUntil(this.#unsubscriber$))
      //     .subscribe({
      //       next: () => {
      //         this.documentService
      //           .getDocumentArchiveId(
      //             this.archiveNumberSelected ?? IntakeConstant.EMPTY_SPACE,
      //             this.submissionId,
      //             this.submissionTypeId,
      //             this.model.submissionSubTypeId ?? null,
      //             EntityTypeId
      //           )
      //           .pipe(takeUntil(this.#unsubscriber$))
      //           .subscribe({
      //             next: () => {
      //               const documentArchiveId: null = null;
      //               this.submissionService
      //                 .submitCommonSectionData(
      //                   this.submissionId,
      //                   submissionStatusId,
      //                   documentArchiveId,
      //                   this.submissionTypeId,
      //                   IsValidArchive
      //                 )
      //                 .pipe(takeUntil(this.#unsubscriber$))
      //                 .subscribe({
      //                   next: (response: string) => {
      //                     this.submissionStatusCommonSection = response;
      //                     this.progressIndicator.hide();
      //                   },
      //                   error: (err: HttpErrorResponse) => {
      //                     this.progressIndicator.hide();
      //                     console.error(
      //                       'An error occurred updating document status as completed with archiveid : ',
      //                       err
      //                     );
      //                   },
      //                 });
      //               this.sharedService.showToastNotification('Completed');
      //               this.router.navigate(['/']);
      //             },
      //             error: (err: HttpErrorResponse) => {
      //               this.progressIndicator.hide();
      //               console.error(
      //                 'An error occurred getting document archive id: ',
      //                 err
      //               );
      //             },
      //           });
      //       },
      //       error: (err: HttpErrorResponse) => {
      //         this.progressIndicator.hide();
      //         console.error('An error on pdf generate api ', err);
      //       },
      //     });
      // } else {
      // **********************commented bcz achive feature is happening in backend
      //   this.isArchiveFeatureEnable &&
      //   this.archiveNumberSelected != IntakeConstant.EMPTY_SPACE &&
      //   this.archiveNumberSelected != null &&
      //   this.archiveNumberSelected != undefined &&
      //   this.archiveNumberSelected != IntakeConstant.ARCHIVE_NOT_LISTED
      // ) {
      //   const EntityTypeId = 1; // 1for intake
      //   this.documentService
      //     .generateArchiveSubmissionPDF(
      //       this.submissionId,
      //       this.opportunityNumber
      //     )
      //     .pipe(takeUntil(this.#unsubscriber$))
      //     .subscribe({
      //       next: () => {
      //         this.documentService
      //           .getDocumentArchiveId(
      //             this.archiveNumberSelected ?? IntakeConstant.EMPTY_SPACE,
      //             this.submissionId,
      //             this.submissionTypeId,
      //             this.model.submissionSubTypeId ?? null,
      //             EntityTypeId
      //           )
      //           .pipe(takeUntil(this.#unsubscriber$))
      //           .subscribe({
      //             next: () => {
      //               const documentArchiveId: null = null;
      //               this.submissionService
      //                 .submitCommonSectionData(
      //                   this.submissionId,
      //                   submissionStatusId,
      //                   documentArchiveId,
      //                   this.submissionTypeId,
      //                   IsValidArchive
      //                 )
      //                 .pipe(takeUntil(this.#unsubscriber$))
      //                 .subscribe({
      //                   next: (response: string) => {
      //                     this.submissionStatusCommonSection = response;
      //                     this.progressIndicator.hide();
      //                   },
      //                   error: (err: HttpErrorResponse) => {
      //                     this.progressIndicator.hide();
      //                     console.error(
      //                       'An error occurred updating document status as completed with archiveid : ',
      //                       err
      //                     );
      //                   },
      //                 });
      //               this.sharedService.showToastNotification('Completed');
      //               this.router.navigate(['/']);
      //             },
      //             error: (err: HttpErrorResponse) => {
      //               this.progressIndicator.hide();
      //               console.error(
      //                 'An error occurred getting document archive id: ',
      //                 err
      //               );
      //             },
      //           });
      //       },
      //       error: (err: HttpErrorResponse) => {
      //         this.progressIndicator.hide();
      //         console.error('An error on pdf generate api ', err);
      //       },
      //     });
      // } else {
      this.submissionService
        .submitCommonSectionData(
          this.submissionId,
          submissionStatusId,
          this.submissionTypeId,
          IsValidArchive
        )
        .pipe(takeUntil(this.#unsubscriber$))
        .subscribe({
          next: (response: string) => {
            this.submissionStatusCommonSection = response;
            this.progressIndicator.hide();
            this.sharedService.showToastNotification('Completed');
            this.router.navigate(['/']);
          },
          error: (err: HttpErrorResponse) => {
            this.progressIndicator.hide();
            console.error(
              'An error occurred updating document status as completed with archiveid : ',
              err
            );
          },
        });
    }
    // }
  }
  onclickResubmitForReviewBtn(): void {
    if (!this.isResubmitBtnDisabled) {
      this.resubmitCommonSectionData();
    }
  }

  onProposalCloseoutChange(): void {
    // this.showAdditionalRMDocMsg = true;
    this.isFinalDocumentAcceptedMsgShow = true;
    this.isArchiveAndCompleteBtnDisabled = true;

    if (this.isStatusPendingCloseout()) {
      if (this.selectedSwapAction === this.swapArchiveFinalize) {
        // this.showAdditionalRMDocMsg = false;
        if (this.isArchiveReadyDocPresent) {
          this.isFinalDocumentAcceptedMsgShow = false;
          this.isArchiveAndCompleteBtnDisabled = false;
        }
      } else if (
        this.selectedSwapAction === this.swapReviewedDocResubmit &&
        this.isValidDocInResubmitTable
      ) {
        // this.showAdditionalRMDocMsg = false;
      }
    }
  }

  setWbsAndArchiveValues(wbsArchiveValue: any): void {
    this.isArchiveNotListed =
      wbsArchiveValue?.archiveNumber === IntakeConstant.ARCHIVE_NOT_LISTED ||
      wbsArchiveValue?.isArchiveNotAvailable;

    if (this.isArchiveNotListed) {
      this.model.archiveNumber = null;
      this.model.isArchiveNotAvailable = true;
    } else {
      this.model.archiveNumber = wbsArchiveValue.archiveNumber;
      this.model.isArchiveNotAvailable = false;
    }

    this.archiveNumberSelected = this.model.archiveNumber;

    this.model.archiveName = wbsArchiveValue?.archiveName ?? null;
    this.model.archiveID = wbsArchiveValue?.archiveID ?? null;
    this.model.archiveFolder =
      wbsArchiveValue.archiveFolder?.length > 0
        ? wbsArchiveValue.archiveFolder
        : null;
    this.model.archiveDescription = wbsArchiveValue?.archiveDescription ?? null;
    this.model.archiveStatus = wbsArchiveValue?.archiveStatus ?? null;
    this.model.archiveFoldersArray =
      wbsArchiveValue.archiveFoldersArray?.length > 0
        ? wbsArchiveValue.archiveFoldersArray
        : null;

    this.model.otherUpdatedVersionForReview =
      this.submissionData.otherUpdatedVersionForReview; // in v3 not used

    this.model.business = wbsArchiveValue?.business ?? null;
    this.model.clientNumber = wbsArchiveValue?.clientNumber ?? null;
    this.model.clientName = wbsArchiveValue?.clientName ?? null;
    this.model.partner = wbsArchiveValue?.partner ?? null;

    this.iswbsCheckboxSelected = this.model.isWBSPending = //
      wbsArchiveValue?.isWBSPending ?? false;
    this.model.wbsChargeCode = wbsArchiveValue?.wbsChargeCode ?? null;
    this.model.wbsDescription = wbsArchiveValue?.wbsDescription ?? null;
  }

  onWbsOrArchiveChange(wbsArchiveDetails: WbsWithArchiveDetailsModel): void {
    this.setWbsAndArchiveValues(wbsArchiveDetails);

    this.#saveCommonSectionDetails();

    // TODO: Can remove isStatusPendingCloseout check as WBS is available on pendingcloseout only.
    if (this.isStatusPendingCloseout()) {
      this.checkPendingCloseoutFlags();
      this.checkValidation();
    }
  }

  handleDocumentTableData(
    data: IntakeDocumentTableModel[],
    tableId: number
  ): void {
    this.documentTableData = data;
    // TODO: Use proposal id from submissiontypeidmapper
    this.hasProposalTypeDoc = this.documentTableData.some(
      (doc) => Number(doc.documentTypeId) === IntakeConstant.Proposal_ID //proposal type ID
    );

    if (this.isStatusPendingCloseout()) {
      // If we upload a doc in archivefinalize of draft status and if it should be considered for Resubmit
      // Add ArchiveFinalize and AllDoc condition in the below if condition.
      if (tableId === this.tableIdMapper['ResubmitTable']) {
        this.isValidDocInResubmitTable = data.some(
          (item: IntakeDocumentTableModel) =>
            resubmitDraftDocStatus.includes(item.documentStatus) &&
            this.currentStatusChangeDate &&
            compareDates(item.createdDate, this.currentStatusChangeDate) === 1 // doccreated > currentStatus
        );
      }

      if (
        tableId === this.tableIdMapper['ArchiveFinalizeTable'] ||
        tableId === this.tableIdMapper['AllDocTable']
      ) {
        this.isArchiveReadyDocPresent = data.some(
          (item: IntakeDocumentTableModel) =>
            archiveDocStatus.includes(item.documentStatus) &&
            (this.submissionTypeCode === this.submissionTypeCodeCO
              ? item.documentType === IntakeDocumentType.ChangeOrder
              : this.submissionTypeCode === this.submissionTypeCodeELSOW
              ? item.documentType === IntakeDocumentType.EngagementLetterOrSOW
              : true)
        );
      }

      if (this.submissionTypeCode === this.submissionTypeCodePro) {
        this.onProposalCloseoutChange();
      } else {
        this.checkPendingCloseoutFlags();
      }
    }
    this.checkValidation();
  }

  checkPendingCloseoutFlags(): void {
    if (this.selectedSwapAction === this.swapArchiveFinalize) {
      this.isFinalDocumentAcceptedMsgShow = true;
      this.isArchiveAndCompleteBtnDisabled = true;

      if (this.isArchiveReadyDocPresent) {
        this.isFinalDocumentAcceptedMsgShow = false;
        this.isArchiveAndCompleteBtnDisabled = !(
          this.iswbsCheckboxSelected ||
          (!!this.model.wbsChargeCode &&
            (!!this.model.archiveNumber || this.model.isArchiveNotAvailable))
        );
      }
    }
  }

  isSubmissionInReadOnlyStatus(): boolean {
    return (
      this.submissionStatus === IntakeOppertunitySubmissionStatus.COMPLETED ||
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.COMPLETED_ADMIN ||
      this.submissionStatus === IntakeOppertunitySubmissionStatus.DISCONTINUED
    );
  }

  isLoggedInUserOnlyEngagementTeamMember(): boolean {
    const engagementTeamMember = this.userRolesAccess.every(
      (role: any) => role.roleName === RoleEnum.ENGAGEMENT_TEAM_MEMBER
    );
    return (
      engagementTeamMember &&
      (this.submissionStatus === IntakeOppertunitySubmissionStatus.SUBMITTED ||
        this.submissionStatus === IntakeOppertunitySubmissionStatus.RESUBMITTED)
    );
  }

  isSubmissionInCompletedOrAdminComplete(): boolean {
    return (
      this.submissionStatus === IntakeOppertunitySubmissionStatus.COMPLETED ||
      this.submissionStatus ===
        IntakeOppertunitySubmissionStatus.COMPLETED_ADMIN
    );
  }

  checkDocumentStatus(status: string): boolean {
    return this.documentTableData.some((doc) => doc.documentStatus === status);
  }

  clearReviewer(
    emailId: string,
    isForTechnicalReviewer: boolean | undefined
  ): void {
    /*
      1. If the workflow is disabled, then the user cannot be removed.
      2. If the required managers length is > 1, then the user can be removed.
      3. If the required manager length is = 1 and user is not required, then the user can be removed.
      4. If the required manager length is = 0 and number of managers are greater than 1, then the user can be removed.
      5. Whether we have R/W permission for role & name
      */
    const canRemoveUser =
      !this.isWorkflowDisabled() &&
      (this.selectedRiskManagers.length > 1 ||
        (this.selectedRiskManagers.length === 1 &&
          !this.selectedRiskManagers.includes(emailId)) ||
        (this.selectedRiskManagers.length === 0 &&
          this.updatedRiskManagerDetails.length > 1)) &&
      (!isForTechnicalReviewer ||
        (isForTechnicalReviewer &&
          this.permissionObj['Intake_Workflow_Technical_Enable']));

    if (canRemoveUser) {
      const index: number = this.updatedRiskManagerDetails.findIndex(
        (reviewer) => reviewer.emailId === emailId
      );
      if (index !== -1) {
        this.updatedRiskManagerDetails[index]['isActive'] = false;
        this.tempUpdatedRiskManagerDetails[index]['isActive'] = false;

        const technicalPresent = this.updatedRiskManagerDetails.some(
          (reviewer) => reviewer.roleName === this.roleTechnicalOrIndependentRM
        );

        if (
          isForTechnicalReviewer &&
          this.isEligibleTechnicalReviewer &&
          !technicalPresent
        ) {
          this.addReviewer(this.roleTechnicalOrIndependentRM);
        }

        this.#updateReviewers(
          UpdateReviewerActions.DELETE,
          this.updatedRiskManagerDetails[index].reviewerRoleId
        );
      }
    }
  }

  clearUpdatedRiskManagers(): void {
    this.updatedRiskManagerDetails = [];
    this.tempUpdatedRiskManagerDetails = [];
    this.selectedRiskManagers = [];
  }

  isEditingReviewer(row: SubmissionApprovers): boolean | undefined {
    const reviewerRoleID = this.roleIdMapper?.[this.roleAdditionalReviewer];
    return (
      row.isEditing &&
      row.reviewerRoleId === reviewerRoleID &&
      !row.isForTechnicalReviewer
    );
  }

  isEditingTechnicalReviewer(row: SubmissionApprovers): boolean | undefined {
    return (
      row.isEditing &&
      row.isForTechnicalReviewer && // if reviewer role is of technical reviewer
      this.isEligibleTechnicalReviewer && // if submission is eligible for technical reviewer
      this.permissionObj['Intake_Workflow_Technical_Enable']
    );
  }

  openOptOutReasonModal(modalBtn?: any): void {
    const optOutModelRef = this.modalService.open(OptOutPopupComponent);
    optOutModelRef
      .onClosed()
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe({
        next: (data: IntakeOptOutPopUpDataModel) => {
          if (data.submissionLevelUpdateSubmission) {
            this.model.reasonForOptOutSelfReview = data.optOutReason;
            this.optOutOfSelfReviewReason = data.optOutReason;
            this.isSelfReviewButtonVisible = false;
            this.showSubmitBtnWhnDraft =
              this.submissionStatus === this.submissionStatusDraft;
            this.sharedService.showToastNotification(
              'Please submit for risk management review'
            );
            this.#saveCommonSectionDetails().add(() => {
              this.documentComponent.triggerDocumentTableDataApi();
            });
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('An error occurred during opening modal: ', err);
        },
      });
  }

  // TODO: Once Employee ID is implemented this needs to be checked
  // checkActionsColumn() {
  //   for (let i in this.updatedRiskManagerDetails) {
  //     if (
  //       this.loggedInEmployeeId ===
  //         this.updatedRiskManagerDetails[i].reviewerId &&
  //       this.submissionStatus === 'Submitted' &&
  //       this.updatedRiskManagerDetails[i].statusReviewedDate === null
  //     ) {
  //       this.showActionsHeader = true;
  //       break;
  //     } else {
  //       this.showActionsHeader = false;
  //     }
  //   }
  // }

  onclickSelfReviewBtn(): void {
    this.submitCommonSectionData(this.submissionStatusSelfPendingCloseout);
  }

  onclickOptOutOfSelfReviewBtn(): void {
    this.openOptOutReasonModal();
  }

  selfReviewAllOperationSet(): void {
    if (this.submissionData.selfReviewEligibilityStatus) {
      this.isSelfReviewButtonVisible = isSelfReviewButtonVisible(
        this.submissionData.selfReviewEligibilityStatus,
        this.submissionStatus as IntakeOppertunitySubmissionStatus | null,
        this.submissionData.reasonForOptOutSelfReview
      );
      if (this.isSelfReviewButtonVisible) {
        this.selfReviewDocBanner =
          this.configData.find(
            (config: configurationType) =>
              config.appConfigurationLabelKey === 'SELFREVIEW_UPLOAD_DOCUMENTS'
          )?.appConfigurationLabelValue || this._EMPTY;
      }
      return;
    }
    this.selfReviewDocBanner = IntakeConstant.EMPTY_SPACE;
  }

  transformStatusStyle(status: string | undefined): StatusEnum {
    if (status) {
      return (
        Object.values(StatusEnum).find((enumValue) => enumValue === status) ||
        StatusEnum.Draft
      );
    } else {
      return StatusEnum.Draft;
    }
  }

  getSubmissionSubType(subTypeId: string | number | undefined | null): string {
    return (
      this.otherSubTypes.find((item) => item.subTypeId.toString() === subTypeId)
        ?.subTypeName || '-'
    );
  }

  isReviewerCheckboxChecked(isRequired: boolean, index: number): boolean {
    if (
      this.submissionStatus == this.submissionStatusDraft &&
      this.selfReviewEligibility == this.valueYes &&
      !this.optOutOfSelfReviewReason
    ) {
      return false;
    }

    return isRequired ?? false;
  }

  isReviewerCheckboxDisabled(emailId: string, index: number): boolean {
    if (
      (this.submissionStatus === IntakeOppertunitySubmissionStatus.SUBMITTED ||
        this.submissionStatus ===
          IntakeOppertunitySubmissionStatus.RESUBMITTED) &&
      this.updatedRiskManagerDetails[index].statusReviewedDate !== null
    ) {
      return true;
    } else if (
      (this.selectedRiskManagers.length === 1 &&
        this.selectedRiskManagers.includes(emailId)) ||
      !this.permissionObj['Intake_Submission_WorkflowCheckbox_Enable']
    ) {
      return true;
    }

    return this.isWorkflowDisabled();
  }

  isWorkflowDisabled(): boolean {
    if (this.submissionStatus == this.submissionStatusDraft) {
      if (
        this.selfReviewEligibility == this.valueYes &&
        !this.optOutOfSelfReviewReason
      ) {
        return true;
      } else {
        return false;
      }
    } else if (
      this.submissionStatus == this.submissionStatusSubmitted ||
      this.submissionStatus == this.submissionStatusResubmitted
    ) {
      return false;
    } else {
      return true;
    }
  }

  checkUserAccess(section: string): boolean {
    const roles: string[] = this.userRolesAccess?.map(
      (role: any) => role.roleName
    );
    if (section === 'AddReviewer') {
      return (
        roles.includes(this.roleRiskManager) ||
        roles.includes(this.roleSupportingRiskManager) ||
        roles.includes(this.roleSpecializedRiskManager) ||
        roles.includes(this.roleTechnicalOrIndependentRM) ||
        roles.includes(this.roleAdditionalReviewer) ||
        roles.includes(this.roleRMSupport) ||
        roles.includes(this.roleSystemAdministrator)
      );
    }
    return false;
  }

  get isAddReviewerButtonDisabled(): boolean {
    return (
      !this.checkUserAccess('AddReviewer') ||
      this.disableFieldOnComplete() ||
      this.isWorkflowDisabled() ||
      this.disableAddReviewerButton ||
      !this.permissionObj['Intake_Submission_WorkflowAddReviewer_Enable']
    );
  }

  isEditDeleteRowDisabled(roleName: string): boolean {
    return (
      !this.checkUserAccess('AddReviewer') ||
      this.disableFieldOnComplete() ||
      this.isWorkflowDisabled() ||
      this.disableAddReviewerButton ||
      (roleName === this.roleAdditionalReviewer &&
        !this.permissionObj['Intake_Submission_WorkflowAddReviewer_Enable']) ||
      (roleName === this.roleTechnicalOrIndependentRM &&
        !this.permissionObj['Intake_Workflow_Technical_Enable'])
    );
  }

  get isResubmitReasonIndicatorVisible(): boolean {
    return (
      ((this.model?.reasonForResubmit?.length ?? 0) > 0 &&
        (this.model?.reasonForResubmit?.length ?? 0) < 15) ||
      (this.isValidDocInResubmitTable &&
        (this.model?.reasonForResubmit?.length ?? 0) === 0)
    );
  }

  get isResubmitBtnDisabled(): boolean {
    return (
      !this.permissionObj['Intake_Submission_ReSubmitBtn_Enable'] ||
      !this.isOpporunityLevelFormCompleted ||
      this.isResubmitReasonIndicatorVisible ||
      !this.isValidDocInResubmitTable
    );
  }

  checkValidationOfForm(): boolean {
    const submissionData = this.model;
    const submissionStatusId = this.submissionData?.submissionStatusId ?? -1;
    const submissionTypeId = this.submissionData?.submissionTypeId ?? -1;

    // Submitted, Re-submitted, Completed, Completed(Admin)
    if ([3, 4, 7, 8, 9].includes(submissionStatusId)) {
      return true;
    }

    if (!this.isValidDocumentUploaded && ![5, 6].includes(submissionStatusId)) {
      return false;
    }

    // Draft, Returned for revisions
    if (
      [1, 2].includes(submissionStatusId) &&
      (this.submissionData.lepReviewedBy !== null ||
        this.submissionData.lepAcknowledgedBy !== null)
    ) {
      switch (submissionTypeId) {
        // Proposal
        case 1:
          return (
            submissionData.relatedToRFP !== null &&
            ((this.model.relatedToRFP ===
              IntakeConstant.NO.toLocaleLowerCase() &&
              this.hasProposalTypeDoc) ||
              (this.hasRFP &&
                this.model.relatedToRFP === IntakeConstant.YES.toLowerCase()))
          );
        // ELSOW
        case 2:
          return true; // In ELSOW we check valid doc
        // CO
        case 3:
          return (
            !!submissionData.coDescription &&
            submissionData.coChangeScope !== null
          );
        // DEL
        case 4:
          return !!submissionData.delDescription;
        // Other
        case 5:
          return !!submissionData.otherDescription;
        default:
          return false;
      }
    }

    // RM/Self/Incomplete - Pending Closeout
    if ([5, 6, 10].includes(submissionStatusId)) {
      switch (submissionTypeId) {
        case 1:
          return this.selectedSwapAction === this._EMPTY ||
            this.selectedSwapAction === this.swapArchiveFinalize
            ? this.isArchiveReadyDocPresent
            : !this.isResubmitBtnDisabled;
        case 2:
        case 3:
        case 4:
        case 5:
          // TODO: Need to check archive too
          return this.selectedSwapAction === this._EMPTY ||
            this.selectedSwapAction === this.swapArchiveFinalize
            ? !this.isArchiveAndCompleteBtnDisabled
            : !this.isResubmitBtnDisabled;

        default:
          return false;
      }
    }
    return false;
  }

  updateWbsStatus(event: any): void {}

  get isInternalQRMDisabled(): boolean {
    return (
      !this.permissionObj['Intake_Submission_InternalQRM_Enable'] ||
      this.isSubmissionInReadOnlyStatus()
    );
  }

  get isInternalQRMVisible(): boolean {
    return (
      this.permissionObj['Intake_Submission_InternalQRM_Visible'] &&
      this.userRolesAccess?.some((role: any) => {
        // TODO: Do we need to check roles for QRM
        if (
          role.roleName == RoleEnum.RISK_MANAGER ||
          role.roleName == RoleEnum.SUPPORTING_RISK_MANAGER ||
          role.roleName == RoleEnum.SPECIALIZED_RISK_MANAGER ||
          role.roleName == RoleEnum.TECHNICAL_INDEPENDENT_RISK_MANAGER ||
          role.roleName == RoleEnum.SYSTEM_ADMINISTRATOR ||
          role.roleName == RoleEnum.SYSTEM_ADMINISTRATOR ||
          role.roleName == RoleEnum.ENGAGEMENT_TEAM_MEMBER ||
          (role.roleName == RoleEnum.REVIEWER &&
            this.updatedRiskManagerDetails.some(
              (item) =>
                item.roleName === RoleEnum.REVIEWER &&
                item.reviewerId === this.currentLoggedInUser
            ))
        ) {
          return true;
        } else {
          return false;
        }
      })
    );
  }

  userInWorkflowTable(): boolean {
    return this.updatedRiskManagerDetails.some(
      (item) => item.reviewerId === this.currentLoggedInUser
    );
  }

  loggedUserReqdInWorkflowTable(index: number = -1): boolean {
    if (index !== -1) {
      const detail: SubmissionApprovers = this.updatedRiskManagerDetails[index];
      return (
        detail.reviewerId === this.currentLoggedInUser && detail.isRequired
      );
    }
    return this.updatedRiskManagerDetails.some(
      (item) => item.reviewerId === this.currentLoggedInUser && item.isRequired
    );
  }

  checkButtonVisibility(): void {
    if (
      (this.submissionStatus === this.submissionStatusSubmitted ||
        this.submissionStatus === this.submissionStatusResubmitted) &&
      this.userInWorkflowTable()
    ) {
      const reviewerData = this.updatedRiskManagerDetails.find(
        (reviewer) => reviewer.reviewerId === this.currentLoggedInUser
      );
      this.updatePermissions.emit(); // TO update the permissions for workflowActions
      this.showReviewAndReturnBtn = reviewerData?.isRequired ?? false;
      if (reviewerData?.statusReviewedDate === null) {
        this.showReviewBtn = true;
      } else {
        this.showReviewBtn = false;
      }
    } else {
      this.showReviewAndReturnBtn = false;
      this.showReviewBtn = false;
    }
  }

  openRelinkModel(modalBtn?: any): void {
    const relinkModel = this.modalService.open(RelinkOppPopupComponent, {
      documentInitiatedDetails: {
        submissionId: this.submissionId,
        opportunityId: this.dataOpportunityId,
      },
    });
    relinkModel
      .onClosed()
      .pipe(takeUntil(this.#unsubscriber$))
      .subscribe((data: NavigationInfoRelinkModel) => {
        if (data) {
          this.reloadCurrentRoute(data);
        }
        if (modalBtn) {
          modalBtn?.focus();
        }
      });
  }

  async reloadCurrentRoute(data: NavigationInfoRelinkModel): Promise<void> {
    const link = `submission/opportunity-details/${data.opportunityId}`;
    const queryParams = {
      submissionId: data.submissionId,
    };
    await this.router.navigateByUrl('/', { skipLocationChange: true });
    await this.router.navigate([link], { queryParams: queryParams });
  }

  scrollToTop(): void {
    this.headerService.scrollToTop();
  }

  trackByValue(index: number, item: DropdownItemOptions): string {
    return item.value;
  }

  swapSectionSelected(event: string): void {
    this.submissionService.setSwapActionSelected(event, false);

    // When we move between section, GetSubmissionDetails is not called and we see old data.
    this.archiveDetails = {
      archiveName: this.model.archiveName,
      archiveNumber: this.isArchiveNotListed
        ? IntakeConstant.ARCHIVE_NOT_LISTED
        : this.model.archiveNumber,
      archiveDescription: this.isArchiveNotListed
        ? IntakeConstant.ARCHIVE_NOT_LISTED
        : this.model.archiveDescription,
    };
  }

  get showPendingCloseoutActionSelect(): boolean {
    // For Pending closeout status, swap action should be selected else show options page
    if (
      (this.submissionStatus === this.submissionStatusRMPendingCloseout ||
        this.submissionStatus === this.submissionStatusSelfPendingCloseout ||
        this.submissionStatus ===
          this.submissionStatusIncompletePendingCloseout) &&
      !this.selectedSwapAction
    ) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.#unsubscriber$.next(this._EMPTY);
    this.#unsubscriber$.complete();
    this.submissionService.openAdminCompleteModal(false);
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.submissionService.setSelectedOpportunityDocStatus(null);
    this.submissionService.setSwapActionSelected(
      SharedConstant.EMPTY_STRING,
      false
    );
  }
}
